import React, { useEffect, useState, useMemo, useRef, useContext } from "react";
import {
  Step,
  Button,
  Dialog,
  IconButton,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import "./tyesInvestor.scss";
import "../../pages/SafeAggrement/SafeAggrement.scss";
import { Country, State, City } from "country-state-city";
import {
  fetIpAddress,
  GetcmsContent,
  RequestNextStage,
} from "../../utils/Api/api";
import useGeoLocation from "../geoLocation/GeoLoaction";
import parser from "html-react-parser";
import { toast } from "react-toastify";
import { toastCommonestyle } from "../../utils/Toast";
import { ShimmerLoaderwhite } from "../../utils/loader/ShimmerLoader";
import PhoneInput from "react-phone-input-2";
import useValidation from "../../utils/useValidation";
import "react-phone-input-2/lib/style.css";
import LoadingButton from "@mui/lab/LoadingButton";
import { SignaturePad } from "../../utils/SignatureTool/SignaturePad";
import { debounce } from "lodash";
import {
  deleteFromIndexedDB,
  getFromIndexedDB,
  saveToIndexedDB,
} from "../../utils/indexDB/indexDB";
import SafeAggrement from "../../pages/SafeAggrement/SafeAggrement";
import CloseIcon from "@mui/icons-material/Close";

import dayjs from "dayjs";
import { getDocumentSection } from "../../pages/PPMContent/Intro";
import { Context } from "../../contextApi/contextProvider";
import SmartSelect from "./SmartSelect";

interface Step {
  id: number;
  label: string;
}

interface FileUploadProps {
  GovernmentIssuedID: string | "";
  GovernmentIssuedIDData: string | "";
  GovernmentIssuedIDExtenstion: string | "";
  ProofOfAddress: string | "";
  ProofOfAddressExtenstion: string | "";
  ProofOfAddressData: string | "";
  EmploymentProofOfRepresentation: string | "";
  EmploymentProofOfRepresentationData: string | "";
  EmploymentProofOfRepresentationExtenstion: string | "";
  CertificateOfIncorporation: string | "";
  CertificateOfIncorporationExtenstion: string | "";
  CertificateOfIncorporationData: string | "";
}

const darkPhoneInputContainerStyle: React.CSSProperties = {
  // Styles for the main container (flag, country code, and input)
  // paddingTop:"10px" ,
  borderRadius: "5px", // Match your select component border-radius
  // Ensure the container itself has a dark background if needed, or let children cover it
  backgroundColor: "transparent",
  background: "transparent",
  // transform :" translateY(10px)",
  marginTop: "5px",

  height: "43px",
  color: "black",
  fontSize: "14px",
  appearance: "none",
  // width: "100%",
  // padding: "10px 20px 10px 50px",
  border: "none",
  outline: "none",
  transition: "border-color 0.3s ease",
};

const darkPhoneInputButtonStyle: React.CSSProperties = {
  background: "#10152f",
  borderColor: "#1e293b",
  height: "43px",
  border: "1px solid #1e293b",
  borderRadius: "5px 0 0 5px",
  borderRight: "none",
  color: "#fff",
};

const darkPhoneInputStyle: React.CSSProperties = {
  background: "#10152f",
  color: "#fff",
  border: "1px solid #1e293b",
  borderRadius: "0 5px 5px 0",
  height: "43px",
  fontSize: "14px",
  width: "100%",
};

const formatDate = (date: string | Date) => {
  const d = new Date(date);
  const month = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};
const steps: Step[] = [
  { id: 1, label: "Agreement" },
  { id: 2, label: "Information" },
  { id: 3, label: "Attachment" },
  { id: 4, label: "Amount" },
  { id: 5, label: "Bank Information" },
  { id: 6, label: "Declaration & Signatures" },
];
const darkSelectStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: "#10152f",
    borderColor: state.isFocused ? "#2B7FFF" : "#1e293b",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(43,127,255,0.25)" : "none",
    borderRadius: "4px",
    color: "#fff",
    minHeight: "45px",
    height: "45px",
    paddingLeft: "4px",
    marginTop: "5px",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#2B7FFF",
    },
  }),

  valueContainer: (provided: any) => ({
    ...provided,
    padding: "0 10px",
    color: "#fff",
  }),

  singleValue: (provided: any) => ({
    ...provided,
    color: "#fff",
  }),

  placeholder: (provided: any) => ({
    ...provided,
    color: "#9aa6bd",
  }),

  input: (provided: any) => ({
    ...provided,

    width: "100% !important",
    minWidth: "100% !important",
    maxWidth: "100% !important",

    color: "#fff !important",
    background: "transparent !important",

    border: "0 !important",
    outline: "0 !important",
    boxShadow: "none !important",
    padding: "0 !important",
    margin: "0 !important",

    /** 🔥 HARD BLOCK global input:focus styles */
    "&:focus": {
      border: "0 !important",
      outline: "0 !important",
      boxShadow: "none !important",
    },
    "&:focus-visible": {
      border: "0 !important",
      outline: "0 !important",
      boxShadow: "none !important",
    },
    "&:focus-within": {
      border: "0 !important",
      outline: "0 !important",
      boxShadow: "none !important",
    },
  }),

  menu: (provided: any) => ({
    ...provided,
    backgroundColor: "#101728",
    borderRadius: "8px",
    border: "1px solid #1e293b",
    marginTop: "5px",
    zIndex: 99,
  }),

  menuList: (provided: any) => ({
    ...provided,
    backgroundColor: "#101728",
    paddingTop: 0,
    paddingBottom: 0,
    maxHeight: "220px",
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#2B7FFF"
      : state.isFocused
      ? "rgba(43,127,255,0.1)"
      : "transparent",
    color: "#fff",
    cursor: "pointer",
    padding: "10px 12px",
    transition: "background 0.2s ease",
  }),

  indicatorsContainer: (provided: any) => ({
    ...provided,
    color: "#cbd5e1",
  }),

  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    color: state.isFocused ? "#2B7FFF" : "#cbd5e1",
    paddingRight: "10px",
    "&:hover": {
      color: "#2B7FFF",
    },
  }),

  indicatorSeparator: (provided: any) => ({
    ...provided,
    backgroundColor: "#334155",
  }),
};

export type SafeIndividualInvestorInfoType = {
  LastName: string;
  FirstName: string;
  DateOfBirth: string;
  Address: string;
  Country: string;
  State: string;
  City: string;
  PostalCode: string;
  PhoneNumber: string;
  Email: string;
  TaxFileNumber: string;
  TaxResidencyCountry: string;
  PassportNumber: string;
  DriversLicenseNumber: string;
  InvestorType: string;
};

export type AttachmentType = {
  GovernmentIssuedID: string;
  GovernmentIssuedIDData: string;
  GovernmentIssuedIDExtenstion: string;
  ProofOfAddress: string;
  ProofOfAddressExtenstion: string;
  ProofOfAddressData: string;
  SignatureData: string;
  SignatureExtenstion: string;
  Signature: string;
};

export type BankType = {
  BankName: string;
  AccountHolderName: string;
  AccountNumber: string;
  BSB: string;
  SwiftCode: string;
  IBANNumber: string;
  BranchAddress: string;
  Country: string | object;
  State: string | object;
  City: string | object;
  Email: string;
  BankPhoneNumber: string;
  PostalCode: string;
  WebSite: string;
};

export type AmountType = {
  SelectCurrency: string;
  SubscriptionAmount: string;
};

export type SignaturesType = {
  FullName: string;
  Position: string;
  Date: string;
  Signatures_i: string;
  Signatures_ii: string;
  Signatures_iii: string;
  Signatures_iv: string;
  Signatures_v: string;
  DeclarationTermsAndCondition: string;
};

export type InvestorFormDataType = {
  SafeIndividualInvestorInfo: SafeIndividualInvestorInfoType[];
  SafeAgreementTermsAndCondition: string;
  Attachment: AttachmentType;
  SafeIndividualInvestorBank: BankType;
  SafeIndividualInvestorAmount: AmountType;
  Signatures: SignaturesType;
  CompanyRepresentative: boolean;
  ValuationCap: string;
  Discount: string;
};
const investorFormData: InvestorFormDataType = {
  SafeIndividualInvestorInfo: [
    {
      LastName: "",
      FirstName: "",
      DateOfBirth: "",
      Address: "",
      Country: "",
      State: "",
      City: "",
      PostalCode: "",
      PhoneNumber: "",
      Email: "",
      TaxFileNumber: "",
      TaxResidencyCountry: "",
      PassportNumber: "",
      DriversLicenseNumber: "",
      InvestorType: "Accredited",
    },
  ],
  SafeAgreementTermsAndCondition: "",
  Attachment: {
    GovernmentIssuedID: "",
    GovernmentIssuedIDData: "",
    GovernmentIssuedIDExtenstion: "",
    ProofOfAddress: "",
    ProofOfAddressExtenstion: "",
    ProofOfAddressData: "",
    SignatureData: "",
    SignatureExtenstion: "",
    Signature: "",
  },
  SafeIndividualInvestorBank: {
    BankName: "",
    AccountHolderName: "",
    AccountNumber: "",
    BSB: "",
    SwiftCode: "",
    IBANNumber: "",
    BranchAddress: "",
    Country: "",
    State: "",
    City: "",
    Email: "",
    BankPhoneNumber: "",
    PostalCode: "",
    WebSite: "",
  },
  SafeIndividualInvestorAmount: {
    SelectCurrency: "USD",
    SubscriptionAmount: "",
  },
  Signatures: {
    FullName: "",
    Position: "",
    Date: new Date().toISOString().split("T")[0],
    Signatures_i: "",
    Signatures_ii: "",
    Signatures_iii: "",
    Signatures_iv: "",
    Signatures_v: "",
    DeclarationTermsAndCondition: "",
  },
  CompanyRepresentative: false,
  ValuationCap: "",
  Discount: "",
};

export default function InvestorFormSteps({
  userName,
  setCurrentStatus,
  getTalk,
}: any) {
  const [open, setOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const bottomRef = useRef<HTMLDivElement>(null);
  const [showScrollButton, setShowScrollButton] = useState(true);
  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    setShowScrollButton(false);
  };
  const { accessDoc, userLoginData } = useContext(Context);
  const [investorAmout, setInvestorAmount] = useState(false);
  const handleScroll = () => {
    const el = contentRef.current;
    if (el) {
      const scrollTop = el.scrollTop;
      const scrollHeight = el.scrollHeight;
      const clientHeight = el.clientHeight;

      const atTop = scrollTop < 60;
      const notAtBottom = scrollHeight - scrollTop - clientHeight > 60;

      if (atTop || notAtBottom) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    }
  };

  const [currentStep, setCurrentStep] = useState<number>(1);
  const [tab, setTab] = useState({
    Instruction: true,
    Information: false,
    Attachment: false,
    Amount: false,
    Bank: false,
    Declaration: false,
  });
  const { isObjectValid } = useValidation();
  const [isStepValid, setIsStepValid] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [htmlStr, setHtmlStr] = useState<string[]>([]);
  const [formData, setFormData] = useState<any>(investorFormData);
  const [activeSelect, setActiveSelect] = useState<string | null>(null);

  const [UserData, setUserData] = useState({
    email: "",
    fname: "",
    lname: "",
    phone: "",
  });
  const [htmlStrRemoved, setHtmlStrRemoved] = useState<string[]>([]);
  const [activeSignatureIndex, setActiveSignatureIndex] = useState<
    number | null
  >(null);
  const [errors, setErrors] = useState<any>([
    {
      LastName: "",
      FirstName: "",
      DateOfBirth: "",
      Address: "",
      Country: "",
      State: "",
      City: "",
      PostalCode: "",
      PhoneNumber: "",
      TaxFileNumber: "",
      Email: "",
      TaxResidencyCountry: "",
      PassportNumber: "",
      DriversLicenseNumber: "",
      InvestorType: "",
    },
  ]);
  const [bankerror, setbankError] = useState({
    BankName: "",
    AccountHolderName: "",
    AccountNumber: "",
    BSB: "",
    SwiftCode: "",
    IBANNumber: "",
    BranchAddress: "",
    Country: "",
    State: "",
    City: "",
    Email: "",
    BankPhoneNumber: "",
    PostalCode: "",
    WebSite: "",
  });
  const [signatureError, setSignatureError] = useState<any>({
    FullName: "",
    Position: "",
    SignatureData: "",
  });
  const validSignuture = (name: string, value: string) => {
    let error = "";
    const trimmedValue = value?.trim();
    if (name !== "SignatureData") {
      if (
        trimmedValue &&
        (trimmedValue.length > MAX_LENGTH ||
          containsMaliciousCharacters(trimmedValue))
      ) {
        error = "Invalid input detected. Please remove special characters.";
      }
    }
    if (!error) {
      switch (name) {
        case "Position":
        case "FullName":
        case "CompanyName":
        case "SignatureData":
          if (!trimmedValue) {
            error = "This field is required.";
          }
      }
    }

    setSignatureError((prevErrors: any) => ({ ...prevErrors, [name]: error }));
  };
  const validateStep = (): boolean => {
    let isValid = false;
    switch (currentStep) {
      case 1:
        isValid = formData.SafeAgreementTermsAndCondition ? true : false;
        if (!isValid) {
          toast.info("please accept all terms", toastCommonestyle as any);
        }
        setTab({
          Instruction: true,
          Information: true,
          Attachment: false,
          Amount: false,
          Bank: false,
          Declaration: false,
        });
        break;

      case 2:
        isValid = isObjectValid(formData?.SafeIndividualInvestorInfo);
        if (!isValid) {
          for (let i = 0; i < formData.SafeIndividualInvestorInfo.length; i++) {
            const elem = formData.SafeIndividualInvestorInfo[i];

            for (let key in elem) {
              const value = elem[key];

              if (value !== undefined && value !== null && value !== "") {
                continue;
              } else {
                validateField(key, value, i);
              }
            }
          }
        }
        setTab({
          Instruction: true,
          Information: true,
          Attachment: isValid,
          Amount: false,
          Bank: false,
          Declaration: false,
        });
        break;

      case 3:
        const areAllRequiredFieldsFilled = (
          data: Record<string, string>
        ): boolean => {
          const skipKeys = new Set([
            "SignatureData",
            "Signature",
            "SignatureExtenstion",
          ]);

          for (const key in data) {
            const value = data[key];
            if (!skipKeys.has(key) && (!value || value.trim() === "")) {
              return false; // Non-skipped field is empty
            }
          }

          return true; // All non-skipped fields are filled
        };

        isValid = areAllRequiredFieldsFilled(formData?.Attachment);
        if (!isValid) {
          toast.info(
            "Please upload all the files before continuing",
            toastCommonestyle as any
          );
        }
        setTab({
          Instruction: true,
          Information: true,
          Attachment: true,
          Amount: isValid,
          Bank: false,
          Declaration: false,
        });
        break;

      case 4:
        isValid = !!formData?.SafeIndividualInvestorAmount.SubscriptionAmount;
        setInvestorAmount(!isValid);
        setTab({
          Instruction: true,
          Information: true,
          Attachment: true,
          Amount: true,
          Bank: isValid,
          Declaration: false,
        });
        break;

      case 5:
        isValid =
          isObjectValid(formData?.SafeIndividualInvestorBank) &&
          isAllFieldsEmpty(bankerror) &&
          (formData?.SafeIndividualInvestorBank.SwiftCode ||
            formData?.SafeIndividualInvestorBank.IBANNumber);
        if (!isValid) {
          const elem = formData?.SafeIndividualInvestorBank;

          for (let key in elem) {
            const value = elem[key];

            if (value !== undefined && value !== null && value !== "") {
              continue;
            } else {
              validateFieldBank(key, value);
            }
          }
        }
        setTab({
          Instruction: true,
          Information: true,
          Attachment: true,
          Amount: true,
          Bank: true,
          Declaration: isValid,
        });
        break;

      case 6:
        const areAllRequiredFieldsFilleds = (
          data: Record<string, string>
        ): boolean => {
          for (const key in data) {
            const value = data[key];
            if (!value || value.trim() === "") {
              return false; // Non-skipped field is empty
            }
          }

          return true; // All non-skipped fields are filled
        };
        isValid =
          areAllRequiredFieldsFilleds(formData?.Signatures) &&
          formData.Attachment.SignatureData;
        // DeclarationTermsAndCondition: "",

        if (!isValid) {
          if (!formData?.Signatures?.DeclarationTermsAndCondition) {
            toast.info("please accept all terms", toastCommonestyle as any);
          }
          if (!formData.Attachment.SignatureData) {
            setSignatureError((prevErrors: any) => ({
              ...prevErrors,
              ["SignatureData"]: "This field is required.",
            }));
          }
          for (let key in formData?.Signatures) {
            validSignuture(key, formData.Signatures[key]);
          }
        }
        setTab({
          Instruction: true,
          Information: true,
          Attachment: true,
          Amount: true,
          Bank: true,
          Declaration: true,
        });
        break;

      default:
        isValid = true;
    }

    return isValid;
  };
  const handleClose = () => {
    setOpen(false);
  };
  const isAllFieldsEmpty = (data: Record<string, string>): boolean => {
    return Object.values(data).every((value) => value === "");
  };
  const loaction = useGeoLocation();
  const handleNext = () => {
    if (currentStep === 5) {
      if (formData.CompanyRepresentative === true) {
        setFormData((prev: any) => {
          const updated = {
            ...prev,
Signatures: {
                          ...prev.Signatures,
              CompanyName:
                prev?.SafeIndividualInvestorInfo?.[1]?.CompanyName || "",
            },
          };
          saveToIndexedDB(userName.email, "form", updated);
          return updated;
        });
      } else {
        setFormData((prev: any) => {
          const updated = {
            ...prev,
            Signatures: {
              ...prev.Signatures,
              FullName: `${
                prev.SafeIndividualInvestorInfo?.[0]?.FirstName || ""
              } ${prev.SafeIndividualInvestorInfo?.[0]?.LastName || ""}`,
            },
          };
          saveToIndexedDB(userName.email, "form", updated);

          return updated;
        });
      }
    }
    if (currentStep < steps.length) {
      if (validateStep()) {
        setCurrentStep((prevStep) => prevStep + 1);
        window.scrollTo(0, 0);
      } else {
        return;
      }
    }
  };


  const safeProps = useMemo(() => {
    return {
      currentStep,
      htmlStr,
      htmlStrRemoved,
      formData,
    };
  }, [currentStep, htmlStr, htmlStrRemoved, formData]);
  const countryOptions = Country?.getAllCountries().map((country) => ({
    value: country.isoCode,
    label: country.name,
  }));
  const getStateOptions = (countryCode: any): any[] => {
    return countryCode
      ? State?.getStatesOfCountry(countryCode).map((state) => ({
          value: state.isoCode,
          label: state.name,
        }))
      : [];
  };

  // Function to get City options dynamically
  const getCityOptions = (countryCode: any, stateCode: any): any[] => {
    return countryCode && stateCode
      ? City.getCitiesOfState(countryCode, stateCode).map((city) => ({
          value: city.name, // ✅ Use a unique value
          label: city.name,
        }))
      : [];
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep((prevStep) => prevStep - 1);
    }
    window.scrollTo(0, 0);
  };
  function convertAttachments(obj: Record<string, any>) {
    const result: any[] = [];

    const grouped: Record<string, any> = {};

    // Group keys by base name (excluding "Data" and "Extenstion")
    Object.keys(obj).forEach((key) => {
      let baseKey = key;

      if (key.endsWith("Data")) {
        baseKey = key.replace("Data", "");
      } else if (key.endsWith("Extenstion")) {
        baseKey = key.replace("Extenstion", "");
      }

      if (!grouped[baseKey]) {
        grouped[baseKey] = {};
      }

      grouped[baseKey][key] = obj[key];
    });

    // Convert to attachment array format
    Object.entries(grouped).forEach(([baseKey, values]) => {
      result.push({
        name: baseKey.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase(), // camelCase to snake_case
        file_name: values[baseKey] || "",
        file_extention: values[`${baseKey}Extenstion`] || "",
        file_data: values[`${baseKey}Data`] || "",
      });
    });

    return result;
  }

  const handleSubmit = async () => {
    setCurrentStatus({
      name: "",
      status: "",
      uid: "",
    });
    setBtnLoading(true);

    try {
      const { data } = await RequestNextStage({
        ip_address: await fetchIpAddress(),
        latitude: await loaction.coordinates.lat,
        longitude: await loaction.coordinates.lng,
        section_id: await getDocumentSection(
          accessDoc?.all_stage_info,
          "Stage 4 - Finalization"
        ),
        ques_and_ans: JSON.stringify({
          SafeIndividual: {
            ...formData,
            Attachment: convertAttachments(formData.Attachment),
          },
        }),
      });

      if (data.status == 200) {
        getTalk();
        deleteFromIndexedDB(userName.email, "form");
        toast.success(data.message, toastCommonestyle as any);
      } else {
        setCurrentStatus(data);
        toast.info(data.message, toastCommonestyle as any);
        getTalk();
      }
      setBtnLoading(false);
    } catch (errors) {
      getTalk();
      toast.error("something went to wrong", toastCommonestyle as any);
      setBtnLoading(false);
    }
  };

  const fetchIpAddress = async () => {
    try {
      const { data } = await fetIpAddress();
      return data;
    } catch (error) {
      return "null";
    }
  };
  const cmsContent = async () => {
    try {
      const response1 = await GetcmsContent({
        ip_address: await fetchIpAddress(),
        form_lat: await loaction.coordinates.lat,
        form_lon: await loaction.coordinates.lng,
        post_id: "11482",
      });
      // setHtmlStr(response1.data?.content?.split("<!--nextpage-->"));
      if (response1?.data?.content) {
        // Split the content
        setHtmlStr(response1?.data?.content?.split("<!--nextpage-->"));

        // Process each part
        const splitContent = response1.data.content.split("<!--nextpage-->");

        // Process each part
        const cleanedContent = splitContent.map((html: any) => {
          // Parse HTML
          const parser = new DOMParser();
          const doc = parser?.parseFromString(html, "text/html");
          doc.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));

          return doc.body.textContent?.trim() || ""; // Extract only text content
        });

        setHtmlStrRemoved(cleanedContent);
      }
    } catch (error) {}
  };
  useEffect(() => {
    cmsContent();
    window.scrollTo(0, 0);
  }, []);

  const handleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
    fileType: keyof FileUploadProps
  ): Promise<void> => {
    const file = e.target.files?.[0];
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "image/jpg",
    ];
    if (!allowedTypes.includes(file.type)) {
      toast.error(
        "Only PDF, JPG, PNG , JPEG files are allowed.",
        toastCommonestyle as any
      );
      return;
    }

    // File size limit check (under 1MB)
    if (file.size > 10 * 1024 * 1024) {
      toast.error("File size must be under 10MB.", toastCommonestyle as any);
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      if (typeof reader.result === "string") {
        const extension = file.name.split(".").pop()?.toLowerCase() || "";

        setFormData((prev: any) => {
          const updated = {
            ...prev,
            Attachment: {
              ...(prev?.Attachment || {}),
              [`${fileType}Data`]: reader.result,
              [`${fileType}`]: file.name,
              [`${fileType}Extenstion`]: extension,
            },
          };

          debouncedSave(updated);
          return updated;
        });
      }
    };

    // Clear file input value
    e.target.value = "";
  };
  useEffect(() => {
    const closeAll = () => setActiveSelect(null);
    window.addEventListener("click", closeAll);
    return () => window.removeEventListener("click", closeAll);
  }, []);

  const handleBankInputChange = (
    field: string,
    value: string,
    validate: any
  ) => {
    setFormData((prev: any) => {
      const updated = {
        ...prev,
        SafeIndividualInvestorBank: {
          ...prev.SafeIndividualInvestorBank,
          [field]: value,
        },
      };
      debouncedSave(updated); // ✅ Persist in IndexedDB if needed
      return updated;
    });

    validate(field, value);
  };

  useEffect(() => {
    if (userName.email) {
      setUserData({
        email: userName.email,
        fname: userName.fname,
        lname: userName.lname,
        phone: userName.phone,
      });
    }
  }, [userName]);
  const MAX_LENGTH = 100;
  const containsMaliciousCharacters = (val: string) =>
    ["<", ">", '"', "'", "`", "=", "{", "}", "(", ")"].some((char) =>
      val.includes(char)
    ) || val.toLowerCase().includes("script");

  const validateFieldBank = (name: string, value: string) => {
    let error = "";
    const trimmedValue = value.trim();

    if (
      trimmedValue &&
      (trimmedValue.length > MAX_LENGTH ||
        containsMaliciousCharacters(trimmedValue))
    ) {
      error = "Invalid input detected. Please remove special characters.";
    }

    if (!error) {
      switch (name) {
        case "BankName":
        case "AccountHolderName":
        case "BranchAddress":
        case "Country":
          if (!trimmedValue) {
            error = "This field is required.";
          } else if (!isNaN(Number(trimmedValue))) {
            error = "Invalid text. Cannot be numbers only.";
          }
          break;

        case "AccountNumber":
          if (
            trimmedValue.length < 10 ||
            trimmedValue.length > 12 ||
            isNaN(Number(trimmedValue))
          ) {
            error = "Account number must be 10 to 12 digits.";
          }
          break;

        case "SwiftCode": {
          const ibanValue =
            formData?.SafeIndividualInvestorBank?.IBANNumber?.trim() || "";

          if (!trimmedValue && !ibanValue) {
            error = "Either Swift Code or IBAN Number is required.";
          } else if (
            trimmedValue &&
            (trimmedValue.length < 8 ||
              trimmedValue.length > 11 ||
              !/^[A-Z0-9]+$/.test(trimmedValue))
          ) {
            error = "SWIFT code must be 8 or 11 uppercase letters/numbers.";
          }

          break;
        }

        case "IBANNumber": {
          const swiftValue =
            formData?.SafeIndividualInvestorBank?.SwiftCode?.trim() || "";

          if (!trimmedValue && !swiftValue) {
            error = "Either IBAN Number or Swift Code is required.";
          } else if (
            trimmedValue &&
            (trimmedValue.length < 15 ||
              trimmedValue.length > 34 ||
              !/^[A-Z0-9]+$/.test(trimmedValue))
          ) {
            error = "IBAN must be 15 to 34 uppercase letters/numbers.";
          }

          break;
        }

        case "WebSite":
          error = "";
          break;

        case "PhoneNumber":
          error = "";
          break;

        case "PostalCode":
          if (
            trimmedValue.length < 4 ||
            trimmedValue.length > 6 ||
            isNaN(Number(trimmedValue))
          ) {
            error = "Postal code must be 4 to 6 digits.";
          }
          break;

        case "Email":
          const atIndex = trimmedValue.indexOf("@");
          const lastDotIndex = trimmedValue.lastIndexOf(".");
          const isValidEmail =
            atIndex > 0 &&
            lastDotIndex > atIndex + 1 &&
            lastDotIndex < trimmedValue.length - 1 &&
            !trimmedValue.includes(" ") &&
            trimmedValue.split("@").length === 2;
          if (!isValidEmail) error = "Invalid Email format.";
          break;

        default:
          break;
      }
    }

    setbankError((prevErrors) => ({ ...prevErrors, [name]: error }));
  };
  const safeParseURL = (value: string): URL | null => {
    try {
      return new URL(value);
    } catch {
      return null;
    }
  };

  const validateField = async (
    name: string,
    value: string,
    index: number,
    tri = true
  ) => {
    setErrors((prevErrors: any) => {
      const newErrors = { ...prevErrors };
      newErrors[index] ??= {};

      let error = "";

      const trimmedValue = typeof value === "string" ? value.trim() : value;
      // Global security checks (applied to all non-empty strings)
      if (
        trimmedValue &&
        tri &&
        (trimmedValue.length > MAX_LENGTH ||
          containsMaliciousCharacters(trimmedValue))
      ) {
        error = "Invalid input detected. Please remove any special characters.";
      }

      if (!error) {
        switch (name) {
          case "FirstName":
          case "LastName":
          case "FounderName":
            if (!trimmedValue) error = "This field is required.";
            else if (!isNaN(Number(trimmedValue)))
              error = "Name cannot be only numbers.";
            break;
          case "TaxFileNumber":
          case "TFN":
          case "TaxID":
          case "SSN":
            if (!trimmedValue) {
              error = "This field is required.";
            } else if (trimmedValue.length < 8 || trimmedValue.length > 15) {
              error = "Tax ID must be between 8 and 15 characters.";
            }
            break;

            // case "TaxResidencyCountry":
            //   if (!trimmedValue) {
            //     error = "Country of Tax Residency is required.";
            //   }
            break;

          // case "PassportNumber":
          //   if (!trimmedValue) {
          //     error = "Passport Number is required.";
          //   } else if (trimmedValue.length < 6) {
          //     error = "Passport Number is too short.";
          //   }
          //   break;

          // case "DriversLicenseNumber":
          //   if (!trimmedValue) {
          //     error = "Driver's License Number is required.";
          //   } else if (trimmedValue.length < 6) {
          //     error = "Driver's License Number is too short.";
          //   }
          //   break;

          case "InvestorType":
            const selectedTypes =
              formData?.SafeIndividualInvestorInfo?.[0]?.InvestorType || [];
            if (!selectedTypes || selectedTypes.length === 0) {
              error = "Please select at least one investor type.";
            }
            break;
          case "DateOfBirth":
          case "EstablishedOn":
            if (!value) {
              error = "Please enter a valid date.";
            } else {
              const selectedDate = dayjs(value);
              const eighteenYearsAgo = dayjs().subtract(18, "year");

              if (selectedDate.isAfter(eighteenYearsAgo)) {
                error = "Date must be at least 18 years ago.";
              }
            }
            break;

          case "BranchAddress":
          case "Address":
            if (!trimmedValue) error = "Address is required.";
            break;

          case "Country":
            if (!value) error = "This field is required.";
            break;

          case "PostalCode":
            const postal = value.replace("-", "");
            if (
              postal.length < 4 ||
              postal.length > 6 ||
              isNaN(Number(postal))
            ) {
              error = "Postal code must be 4 to 6 digits.";
            }
            break;

          case "PhoneNumber":
          case "OfficeNumber":
            const phone = value.replace("+", "");
            if (!trimmedValue) {
              error = "Phone number is required.";
            } else if (
              phone.length < 10 ||
              phone.length > 15 ||
              isNaN(Number(phone))
            ) {
              error = "Invalid phone number format.";
            }
            break;

          case "Email":
          case "OfficeEmail":
            const atIndex = trimmedValue.indexOf("@");
            const lastDotIndex = trimmedValue.lastIndexOf(".");
            const isValidEmail =
              atIndex > 0 &&
              lastDotIndex > atIndex + 1 &&
              lastDotIndex < trimmedValue.length - 1 &&
              !trimmedValue.includes(" ") &&
              trimmedValue.split("@").length === 2;
            if (!isValidEmail) error = "Invalid Email format.";
            break;

          case "CompanyName":
          case "BusinessRegistrationNumber":
          case "TaxFileNumber":
            if (!trimmedValue) error = "This field is required.";
            break;
          case "CompanyType":
            if (!trimmedValue) error = "Company type is required.";
            break;

          case "CountryOfRegistration":
            if (!value) error = "Please select a country.";
            break;
          case "GovernmentRegistrationUrl": {
            if (!trimmedValue) {
              error = "Government registration URL is required.";
              break;
            }

            try {
              const url =
                trimmedValue.startsWith("http://") ||
                trimmedValue.startsWith("https://")
                  ? new URL(trimmedValue)
                  : new URL("https://" + trimmedValue);

              const hostname = url.hostname;
              const parts = hostname.split(".");
              const tld = parts.at(-1);

              if (
                !["http:", "https:"].includes(url.protocol) ||
                parts.length <= 1 ||
                !tld ||
                tld.length < 2 ||
                !/^[a-zA-Z]+$/.test(tld) ||
                parts.every((p) => /^\d+$/.test(p)) ||
                parts.some(
                  (p) => p.length === 0 || !/^[a-zA-Z0-9-]+$/.test(p)
                ) ||
                trimmedValue.includes(" ") ||
                trimmedValue.includes("..") ||
                trimmedValue.length > 300 ||
                containsMaliciousCharacters(trimmedValue)
              ) {
                error = "Please enter a valid government registration URL.";
                break;
              }
            } catch {
              error = "Invalid URL format.";
              break;
            }

            break;
          }

          case "TaxID":
            if (!trimmedValue) error = "Tax ID is required.";
            else if (trimmedValue.length < 6 || trimmedValue.length > 20)
              error = "Tax ID must be between 6 to 20 characters.";
            break;
          case "CompanyWebSite": {
            if (!trimmedValue) break;

            let value = trimmedValue.trim();

            // ❌ spaces not allowed
            if (value.includes(" ")) {
              error = "Spaces are not allowed in website URL";
              break;
            }

            // ➕ add protocol if missing
            if (!value.startsWith("http://") && !value.startsWith("https://")) {
              value = "https://" + value;
            }

            const url = safeParseURL(value);

            // ❌ invalid URL
            if (!url) {
              error = "Please enter a valid website URL";
              break;
            }

            // ❌ only http / https
            if (url.protocol !== "http:" && url.protocol !== "https:") {
              error = "Only http or https URLs are allowed";
              break;
            }

            // ❌ hostname missing
            if (!url.hostname) {
              error = "Invalid website domain";
              break;
            }

            // ❌ must contain dot
            if (!url.hostname.includes(".")) {
              error = "Website domain must contain a dot (example.com)";
              break;
            }

            // ❌ max length
            if (value.length > 2048) {
              error = "Website URL is too long";
              break;
            }

            break;
          }
          default:
            break;
        }
      }

      if (error) {
        newErrors[index][name] = error;
      } else {
        delete newErrors[index][name];
        if (Object.keys(newErrors[index]).length === 0) {
          delete newErrors[index];
        }
      }

      return { ...newErrors };
    });
  };

  const isPDFFile = (filename: string) =>
    filename.split(".").pop()?.toLowerCase() === "pdf";
  const getMinAllowedDate = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 18); // Subtract 18 years
    return today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };
  // index db
  const companyRepresentativeFlag = async (flag: boolean) => {
    if (flag) {
      setFormData((prev: any) => {
        const updated = {
          ...prev,
          SafeIndividualInvestorInfo: [
            ...prev.SafeIndividualInvestorInfo,
            {
              CompanyName: "",

              Address: "",
              Country: "",
              State: "",
              City: "",
              BusinessRegistrationNumber: "",
              TaxFileNumber: "",
              CompanyWebSite: "",
              PostalCode: "",
              OfficeNumber: "",
              OfficeEmail: "",
              CompanyType: "",
              CountryOfRegistration: "",
              GovernmentRegistrationUrl: "",
              TaxResidencyCountry: "",
            },
          ],
          Attachment: {
            ...prev.Attachment,
            EmploymentProofOfRepresentation: "",
            EmploymentProofOfRepresentationData: "",
            EmploymentProofOfRepresentationExtenstion: "",
            CertificateOfIncorporation: "",
            CertificateOfIncorporationExtenstion: "",
            CertificateOfIncorporationData: "",
          },
          SafeIndividualInvestorBank: {
            ...prev.SafeIndividualInvestorBank,
          },
          SafeIndividualInvestorAmount: {
            ...prev.SafeIndividualInvestorAmount,
          },

          Signatures: {
            Position: formData?.Signatures?.Position ?? "",
            CompanyName: formData?.SafeIndividualInvestorInfo?.[1]?.CompanyName,
            Signatures_i: formData?.Signatures?.Signatures_i ?? "",
            Signatures_ii: formData?.Signatures?.Signatures_ii ?? "",
            Signatures_iii: formData?.Signatures?.Signatures_iii ?? "",
            Signatures_iv: formData?.Signatures?.Signatures_iv ?? "",
            Signatures_v: formData?.Signatures?.Signatures_v ?? "",
            DeclarationTermsAndCondition:
              formData?.Signatures?.DeclarationTermsAndCondition ?? "",
            Date: formatDate(new Date()),
          },
          CompanyRepresentative: true,
          ValuationCap: formData?.ValuationCap,
          Discount: formData?.Discount,
          SafeAgreementTermsAndCondition:
            formData?.SafeAgreementTermsAndCondition,
        };

        debouncedSave(updated);
        setSignatureError({
          CompanyName: "",
          Position: "",
          SignatureData: "",
        });
        setErrors([
          {
            ...errors[0],
          },
          {
            CompanyName: "",

            Address: "",
            Country: "",
            State: "",
            City: "",
            BusinessRegistrationNumber: "",
            TaxFileNumber: "",
            CompanyWebSite: "",
            PostalCode: "",
            OfficeNumber: "",
            OfficeEmail: "",
            CompanyType: "",
            CountryOfRegistration: "",
            GovernmentRegistrationUrl: "",

            TaxResidencyCountry: "",
          },
        ]);

        return updated;
      });
    } else {
      const baseInfo = formData.SafeIndividualInvestorInfo[0]
        ? JSON.parse(JSON.stringify(formData.SafeIndividualInvestorInfo[0]))
        : {
            LastName: "",
            FirstName: "",
            DateOfBirth: "",
            Address: "",
            Country: "",
            State: "",
            City: "",
            PostalCode: "",
            PhoneNumber: "",
            TaxFileNumber: "",
            Email: "",
            TaxResidencyCountry: "",
            PassportNumber: "",
            DriversLicenseNumber: "",
            InvestorType: "Accredited",
          };

      const updated = {
        SafeIndividualInvestorInfo: [baseInfo],

        Attachment: {
          GovernmentIssuedID: formData?.Attachment?.GovernmentIssuedID ?? "",
          GovernmentIssuedIDData:
            formData?.Attachment?.GovernmentIssuedIDData ?? "",
          GovernmentIssuedIDExtenstion:
            formData?.Attachment?.GovernmentIssuedIDExtenstion ?? "",
          ProofOfAddress: formData?.Attachment?.ProofOfAddress ?? "",
          ProofOfAddressExtenstion:
            formData?.Attachment?.ProofOfAddressExtenstion ?? "",
          ProofOfAddressData: formData?.Attachment?.ProofOfAddressData ?? "",
          SignatureData: formData?.Attachment?.SignatureData ?? "",
          SignatureExtenstion: formData?.Attachment?.SignatureExtenstion ?? "",
          Signature: formData?.Attachment?.Signature ?? "",
        },
        SafeIndividualInvestorBank: {
          BankName: formData?.SafeIndividualInvestorBank?.BankName ?? "",
          AccountHolderName:
            formData?.SafeIndividualInvestorBank?.AccountHolderName ?? "",
          AccountNumber:
            formData?.SafeIndividualInvestorBank?.AccountNumber ?? "",
          BSB: formData?.SafeIndividualInvestorBank?.BSB ?? "",
          SwiftCode: formData?.SafeIndividualInvestorBank?.SwiftCode ?? "",
          IBANNumber: formData?.SafeIndividualInvestorBank?.IBANNumber ?? "",
          BranchAddress:
            formData?.SafeIndividualInvestorBank?.BranchAddress ?? "",
          Country: formData?.SafeIndividualInvestorBank?.Country ?? "",
          State: formData?.SafeIndividualInvestorBank?.State ?? "",
          BankPhoneNumber:
            formData?.SafeIndividualInvestorBank?.BankPhoneNumber ?? "",
          City: formData?.SafeIndividualInvestorBank?.City ?? "",
          PostalCode: formData?.SafeIndividualInvestorBank?.PostalCode ?? "",
          WebSite: formData?.SafeIndividualInvestorBank?.WebSite ?? "",
          Email: formData?.SafeIndividualInvestorBank?.Email ?? "",
        },
        SafeIndividualInvestorAmount: {
          SelectCurrency:
            formData?.SafeIndividualInvestorAmount?.SelectCurrency ?? "",
          SubscriptionAmount:
            formData?.SafeIndividualInvestorAmount?.SubscriptionAmount ?? "",
        },

        Signatures: {
          DeclarationTermsAndCondition:
            formData?.Signatures?.DeclarationTermsAndCondition ?? "",
          FullName: formData?.Signatures?.FullName ?? "",
          Position: formData?.Signatures?.Position ?? "",
          Date: formatDate(new Date()),
          Signatures_i: formData?.Signatures?.Signatures_i ?? "",
          Signatures_ii: formData?.Signatures?.Signatures_ii ?? "",
          Signatures_iii: formData?.Signatures?.Signatures_iii ?? "",
          Signatures_iv: formData?.Signatures?.Signatures_iv ?? "",
          Signatures_v: formData?.Signatures?.Signatures_v ?? "",
        },
        CompanyRepresentative: false,
        ValuationCap: formData?.ValuationCap,
        Discount: formData?.Discount,
        SafeAgreementTermsAndCondition:
          formData?.SafeAgreementTermsAndCondition ?? "",
      };
      setSignatureError({
        FullName: "",
        Position: "",
        SignatureData: "",
      });

      setErrors([
        {
          ...errors[0],
        },
      ]);

      await setFormData(updated);
      await debouncedSave(updated);
    }
  };

  const debouncedSave = debounce(async (data) => {
    await saveToIndexedDB(userName.email, "form", data);
  }, 0); // 500ms debounce

  const updateForm = (
    section: string,
    field: string,
    value: string,
    index?: number
  ) => {
    setFormData((prev: any) => {
      let updatedSection;

      if (index !== undefined) {
        const sectionArray = [...(prev[section] || [])];
        const item = { ...sectionArray[index], [field]: value };
        sectionArray[index] = item;
        updatedSection = sectionArray;
      } else {
        updatedSection = {
          ...(prev[section] || {}),
          [field]: value,
        };
      }

      const updatedForm = {
        ...prev,
        [section]: updatedSection,
      };

      if (section === "SafeIndividualInvestorInfo") {
        validateField(field, value, index || 0);
      }

      if (section === "SafeIndividualInvestorBank") {
        validateFieldBank(field, value);
      }

      debouncedSave(updatedForm);
      return updatedForm;
    });
  };
  useEffect(() => {
    if (UserData.email) {
      getFromIndexedDB(userName.email, "form")
        .then((data) => {
          if (data) {
            setFormData(
              structuredClone({
                ...data,
                Signatures: {
                  ...data.Signatures,
                  Date: new Date().toISOString().split("T")[0],
                },
              })
            );
            if (
              data.SafeIndividualInvestorInfo &&
              Array.isArray(data.SafeIndividualInvestorInfo)
            ) {
              data.SafeIndividualInvestorInfo.forEach(
                (item: any, index: number) => {
                  for (const key in item) {
                    if (
                      item[key] !== undefined &&
                      item[key] != null &&
                      item[key] != ""
                    ) {
                      validateField(key, item[key], index, false);
                    }
                  }
                }
              );

              for (const key in data.SafeIndividualInvestorBank) {
                if (
                  data.SafeIndividualInvestorBank[key] !== undefined &&
                  data.SafeIndividualInvestorBank[key] != null &&
                  data.SafeIndividualInvestorBank[key] != ""
                ) {
                  validateFieldBank(key, data.SafeIndividualInvestorBank[key]);
                }
              }
            }
          } else {
            const update = {
              ...investorFormData,
              SafeIndividualInvestorInfo: [
                {
                  ...investorFormData.SafeIndividualInvestorInfo[0],
                  LastName: userName.lname,
                  FirstName: userName.fname,
                  PhoneNumber: userName.phone,
                  Email: userName.email,
                },
              ],
            };
            update.SafeIndividualInvestorInfo.forEach(
              (item: any, index: number) => {
                for (const key in item) {
                  if (
                    item[key] !== undefined &&
                    item[key] != null &&
                    item[key] != ""
                  ) {
                    validateField(key, item[key], index, false);
                  }
                }
              }
            );

            setFormData(update);
            saveToIndexedDB(userName.email, "form", update).catch(
              console.error
            );
          }
        })
        .catch(console.error);
    }
  }, [UserData]);
  useEffect(() => {
    const closeAll = () => setActiveSelect(null);
    window.addEventListener("click", closeAll);
    return () => window.removeEventListener("click", closeAll);
  }, []);
  return (
    <>
      {htmlStr.length && (
        <div className="watermaring-main-dev">
          <img
            src="https://public.ticca.com/images/svg/Watermark_Business_Summary.svg"
            alt="logo"
          />
          <p>
            Commercial in Confidence <br />
            Content under NDA.
            <br /> {userLoginData?.email}
          </p>
        </div>
      )}
      <div className="investor-form-steps-container">
        <div className="stepper-container">
          {steps.map((step, index) => (
            <div key={step.id} className="step-wrapper">
              <div
                onClick={() => {
                  const key = step.label as keyof typeof tab;
                  if (step.id == 2) {
                    if (formData.SafeAgreementTermsAndCondition) {
                      setCurrentStep(step.id);
                    } else {
                      return;
                    }
                  }
                  if (step.id == 5) {
                    if (tab.Bank) {
                      setCurrentStep(step.id);
                    }
                  } else {
                    if (tab?.[key]) {
                      setCurrentStep(step.id);
                    }
                  }
                }}
                className="step-content"
              >
                {/* Step Circle */}
                <div
                  className={`step-circle ${
                    currentStep >= step.id ? "active" : ""
                  }`}
                >
                  {currentStep > step.id
                    ? "✔"
                    : step.id.toString().padStart(2, "0")}
                </div>
                {/* Step Label Below */}
                <div
                  className={`step-label ${
                    currentStep >= step.id ? "active" : ""
                  }`}
                >
                  {step.label}
                </div>
              </div>
              {/* Connector Line */}
              {index !== steps.length - 1 && (
                <div
                  className={`step-line ${
                    currentStep > step.id ? "active" : ""
                  }`}
                ></div>
              )}
            </div>
          ))}
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          fullScreen
          maxWidth={false}
          sx={{
            zIndex: 99999,
            "& .MuiDialog-paper": {
              borderRadius: 3,
              p: "5px",
              maxHeight: "90vh",
              width: "90vw",
              overflow: "hidden",
              position: "relative",
              background: "linear-gradient(135deg, #0a0e27 0%, #1a1f4d 100%)",
              boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            },
          }}
          PaperProps={{
            sx: {
              width: "90vw",
              p: "5px",
              borderRadius: 3,
              maxHeight: "90vh",
            },
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              zIndex: 99999,
              color: "white",
            }}
          >
            <CloseIcon fill={"white"} />
          </IconButton>

          <DialogContent
            dividers
            ref={contentRef}
            onScroll={handleScroll}
            sx={{
              p: "5px",
              overflowY: "auto",
              position: "relative",
            }}
          >
            {/* Your Safe Agreement */}
            <SafeAggrement
              currentStep={safeProps.currentStep}
              htmlStr={safeProps.htmlStr}
              htmlStrRemoved={safeProps.htmlStrRemoved}
              formData={safeProps.formData}
              setFormData={setFormData}
              debouncedSave={debouncedSave}
              condition={true}
            />

            <div ref={bottomRef} />
            <div className="termsandcondition" style={{ paddingTop: "20px" }}>
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  fontWeight: "bold",
                  fontSize: "16px",
                  fontFamily: "var(--Segoe-Regular)",
                }}
                color="primary"
                onClick={() => {
                  setFormData((prev: any) => {
                    const updated = {
                      ...prev,
                      Signatures: {
                        ...prev.Signatures,
                        DeclarationTermsAndCondition:
                          safeProps?.htmlStrRemoved[64],
                        Signatures_i: safeProps?.htmlStrRemoved[61],
                        Signatures_ii: safeProps?.htmlStrRemoved[62],
                        Signatures_iii: safeProps?.htmlStrRemoved[63],
                        Signatures_iv: safeProps?.htmlStrRemoved[71],
                        Signatures_v: safeProps?.htmlStrRemoved[72],
                      },
                      ValuationCap: `${htmlStrRemoved[85]}`,
                      Discount: `${htmlStrRemoved[87]}`,
                    };
                    debouncedSave(updated);
                    return updated;
                  });
                  handleClose();
                }}
              >
                Accept Declaration Terms And Condition
              </Button>
            </div>
          </DialogContent>

          {/* Scroll Down Button */}
          {showScrollButton && (
            <div className="scroll-down-btn visible">
              <button className="scroll-down" onClick={scrollToBottom}>
                Scroll Down and Agree
              </button>
            </div>
          )}
        </Dialog>
        {htmlStrRemoved.length < 2 && (
          <div className="valuable-question-main-dev">
            {[0, 0, 0, 0, 0, 0, 0, 0].map((elem: number, index: number) => (
              <>
                <ShimmerLoaderwhite maxWidth="100vw" />
              </>
            ))}
          </div>
        )}
        {currentStep == 1 && htmlStrRemoved.length > 2 && (
          <SafeAggrement
            currentStep={safeProps.currentStep}
            htmlStr={safeProps.htmlStr}
            htmlStrRemoved={safeProps.htmlStrRemoved}
            formData={safeProps.formData}
            setFormData={setFormData}
            debouncedSave={debouncedSave}
          />
        )}
        {currentStep == 2 && htmlStrRemoved.length > 2 && (
          <>
            <div
              style={{
                margin: "10px auto",

                padding: "10px 70px",
              }}
              className="amount-investor-container"
            >
              <div className="amount-investor-dividend-option">
                <div>
                  <label>
                    {" "}
                    <b>{htmlStr[11] && htmlStrRemoved[11]}</b>
                  </label>
                </div>
                <div>
                  <input
                    onChange={(e) => {
                      companyRepresentativeFlag(e.target.checked);
                    }}
                    checked={formData?.CompanyRepresentative}
                    type="checkbox"
                  />
                  <label style={{ marginTop: "5px" }}>
                    {htmlStr[12] && parser(htmlStr[12])}
                  </label>
                </div>
              </div>
            </div>
            <div className="investor-form-container">
              <div className="investor-from-dev">
                {formData.CompanyRepresentative
                  ? htmlStr[25] && parser(htmlStr[25])
                  : htmlStr[13] && parser(htmlStr[13])}

                <br />
                <form className="investor-form">
                  <div className="form-row">
                    <label>
                      {htmlStr[14] && parser(htmlStr[14])}
                      <input
                        name="LastName"
                        value={
                          formData?.SafeIndividualInvestorInfo?.[0]?.LastName ||
                          ""
                        }
                        onChange={(e) => {
                          updateForm(
                            "SafeIndividualInvestorInfo",
                            "LastName",
                            e.target.value,
                            0
                          );
                        }}
                        className={`input-claase ${
                          errors?.[0]?.LastName && "error-input"
                        }`}
                        type="text"
                        placeholder="Enter last name"
                      />
                      {errors[0]?.LastName && (
                        <p className="error">{errors?.[0]?.LastName}</p>
                      )}
                    </label>
                    <label>
                      {htmlStr[15] && parser(htmlStr[15])}
                      <input
                        value={
                          formData?.SafeIndividualInvestorInfo?.[0]
                            ?.FirstName || ""
                        }
                        onChange={(e) => {
                          updateForm(
                            "SafeIndividualInvestorInfo",
                            "FirstName",
                            e.target.value,
                            0
                          );
                        }}
                        className={`input-claase ${
                          errors?.[0]?.FirstName && "error-input"
                        }`}
                        type="text"
                        placeholder="Enter first name"
                      />
                      {errors?.[0]?.FirstName && (
                        <p className="error">{errors?.[0]?.FirstName}</p>
                      )}
                    </label>
                    <label className="custom-label">
                      {htmlStrRemoved[16]}
                      <input
                        type="date"
                        min={dayjs("1930-01-01").format("YYYY-MM-DD")}
                        max={dayjs(getMinAllowedDate()).format("YYYY-MM-DD")}
                        value={
                          formData?.SafeIndividualInvestorInfo[0]
                            ?.DateOfBirth || ""
                        }
                        onChange={(e) => {
                          updateForm(
                            "SafeIndividualInvestorInfo",
                            "DateOfBirth",
                            e.target.value,
                            0
                          );
                        }}
                        style={{
                          height: "45px",
                          marginTop: "5px",
                          padding: "10px 14px",
                          borderRadius: "4px",
                          width: "100%",
                          boxSizing: "border-box",
                          backgroundColor: "#10152f", // dark background
                          color: "#fff", // text color
                          border: "1px solid #1e293b", // border
                          outline: "none",
                          transition: "all 0.2s ease",
                        }}
                      />

                      {errors?.[0]?.DateOfBirth && (
                        <p className="error">{errors?.[0]?.DateOfBirth}</p>
                      )}
                    </label>
                  </div>
                  <div className="form-row">
                    <label className="full-width">
                      {htmlStr[17] && parser(htmlStr[17])}
                      <input
                        name="address"
                        className={`input-claase ${
                          errors?.[0]?.Address && "error-input"
                        }`}
                        value={
                          formData?.SafeIndividualInvestorInfo?.[0]?.Address ||
                          ""
                        }
                        onChange={(e) =>
                          updateForm(
                            "SafeIndividualInvestorInfo",
                            "Address",
                            e.target.value,
                            0
                          )
                        }
                        type="text"
                        placeholder="Enter address here"
                      />
                      {errors?.[0]?.Address && (
                        <p className="error">{errors?.[0]?.Address}</p>
                      )}
                    </label>
                  </div>
                  <div className="form-row">
                    <label>
                      {htmlStr[18] && parser(htmlStr[18])}
                      <SmartSelect
                        id="city_1544545"
                        isMulti={false}
                        options={countryOptions}
                        value={
                          formData?.SafeIndividualInvestorInfo?.[0]?.Country
                        }
                        onChange={(selected: {
                          value: string;
                          label: string;
                        }) => {
                          setFormData((prev: any) => {
                            const currentCountry =
                              prev?.SafeIndividualInvestorInfo?.[0]?.Country
                                ?.value;

                            const hasCountryChanged =
                              currentCountry !== selected?.value;

                            const updated = {
                              ...prev,
                              SafeIndividualInvestorInfo:
                                prev.SafeIndividualInvestorInfo.map(
                                  (item: any, index: number) =>
                                    index === 0
                                      ? {
                                          ...item,
                                          Country: selected,
                                          City: hasCountryChanged
                                            ? ""
                                            : item.City,
                                          State: hasCountryChanged
                                            ? ""
                                            : item.State,
                                        }
                                      : item
                                ),
                            };

                            debouncedSave(updated);
                            return updated;
                          });

                          validateField("Country", selected.value, 0);
                        }}
                        className={`  ${errors?.[0]?.Country && "error-input"}`}
                        styles={darkSelectStyles}
                        placeholder="Select country"
                      />

                      {errors?.[0]?.Country && (
                        <p className="error">{errors?.[0]?.Country}</p>
                      )}
                    </label>
                    <label>
                      {htmlStr[19] && parser(htmlStr[19])}
                      <SmartSelect
                        id="city_21344677"
                        isMulti={false}
                        options={getStateOptions(
                          formData?.SafeIndividualInvestorInfo?.[0]?.Country
                            ?.value
                        )}
                        value={formData?.SafeIndividualInvestorInfo?.[0]?.State}
                        onChange={(selected: {
                          value: string;
                          label: string;
                        }) => {
                          setFormData((prev: any) => {
                            const currentState =
                              prev.SafeIndividualInvestorInfo?.[0]?.State
                                ?.value;

                            const hasStateChanged =
                              currentState !== selected?.value;

                            const updated = {
                              ...prev,
                              SafeIndividualInvestorInfo:
                                prev.SafeIndividualInvestorInfo.map(
                                  (item: any, index: number) =>
                                    index === 0
                                      ? {
                                          ...item,
                                          State: selected,
                                          City: hasStateChanged
                                            ? ""
                                            : item.City,
                                        }
                                      : item
                                ),
                            };

                            debouncedSave(updated);
                            return updated;
                          });
                          validateField("State", selected.value, 0);
                        }}
                        className={`  ${errors?.[0]?.State && "error-input"}`}
                        styles={darkSelectStyles}
                        placeholder="Select state"
                        isDisabled={
                          !formData?.SafeIndividualInvestorInfo?.[0]?.Country
                        }
                      />

                      {errors?.[0]?.State && (
                        <p className="error">{errors?.[0]?.State}</p>
                      )}
                    </label>
                    <label>
                      {htmlStr[20] && parser(htmlStr[20])}
                      <SmartSelect
                        id="city_32435466"
                        isMulti={false}
                        options={getCityOptions(
                          formData?.SafeIndividualInvestorInfo?.[0]?.Country
                            ?.value,
                          formData?.SafeIndividualInvestorInfo?.[0]?.State
                            ?.value
                        )}
                        value={formData?.SafeIndividualInvestorInfo?.[0]?.City}
                        onChange={(selected: {
                          value: string;
                          label: string;
                        }) => {
                          setFormData((prev: any) => {
                            const updated = {
                              ...prev,
                              SafeIndividualInvestorInfo:
                                prev?.SafeIndividualInvestorInfo?.map(
                                  (item: any, index: number) =>
                                    index === 0
                                      ? { ...item, City: selected }
                                      : item
                                ),
                            };

                            debouncedSave(updated);
                            return updated;
                          });
                          validateField("City", selected.value, 0);
                        }}
                        className={` ${errors?.[0]?.City && "error-input"}`}
                        styles={darkSelectStyles}
                        placeholder="Select city"
                        isDisabled={
                          !formData?.SafeIndividualInvestorInfo?.[0]?.State
                        }
                      />

                      {errors?.[0]?.City && (
                        <p className="error">{errors?.[0]?.City}</p>
                      )}
                    </label>
                    <label>
                      {htmlStr[21] && parser(htmlStr[21])}
                      <input
                        name="PostalCode"
                        value={
                          formData?.SafeIndividualInvestorInfo[0]?.PostalCode ||
                          ""
                        }
                        onChange={(e) =>
                          updateForm(
                            "SafeIndividualInvestorInfo",
                            "PostalCode",
                            e.target.value,
                            0
                          )
                        }
                        className={`input-claase ${
                          errors?.[0]?.PostalCode && "error-input"
                        }`}
                        type="text"
                        placeholder="Enter postal code here"
                      />
                      {errors?.[0]?.PostalCode && (
                        <p className="error">{errors?.[0]?.PostalCode}</p>
                      )}
                    </label>
                  </div>
                  <div className="form-row">
                    <div className="dark-phone-input">
                      <label style={{ marginBottom: "6px" }}>
                        {htmlStr[22] && parser(htmlStr[22])}
                      </label>
                      <PhoneInput
                        country={"us"}
                        inputClass={`select-input ${
                          errors?.[0]?.PhoneNumber ? "error-input" : ""
                        }`}
                        inputStyle={darkPhoneInputStyle}
                        // Apply the dark theme style to the button (flag/dropdown)
                        buttonStyle={darkPhoneInputButtonStyle}
                        // Apply container styles (like margin-top and overall border-radius)
                        containerStyle={darkPhoneInputContainerStyle}
                        value={
                          formData?.SafeIndividualInvestorInfo?.[0]?.PhoneNumber
                        }
                        onChange={(phone: string) => {
                          setFormData((prev: any) => {
                            const updated = {
                              ...prev,
                              SafeIndividualInvestorInfo:
                                prev?.SafeIndividualInvestorInfo?.map(
                                  (item: any, index: number) =>
                                    index === 0
                                      ? { ...item, PhoneNumber: phone }
                                      : item
                                ),
                            };
                            debouncedSave(updated);
                            return updated;
                          });
                          validateField("PhoneNumber", phone, 0);
                        }}
                        inputProps={{
                          name: "PhoneNumber",
                          required: true,
                        }}
                      />
                      {errors?.[0]?.PhoneNumber && (
                        <p className="error">
                          <b>{errors?.[0]?.PhoneNumber}</b>
                        </p>
                      )}
                    </div>

                    <label>
                      {htmlStr[73] && parser(htmlStr[73])}
                      <input
                        className={`input-claase ${
                          errors?.[0]?.TaxFileNumber && "error-input"
                        }`}
                        name="TaxFileNumber"
                        value={
                          formData?.SafeIndividualInvestorInfo?.[0]
                            ?.TaxFileNumber || ""
                        }
                        onChange={(e) =>
                          updateForm(
                            "SafeIndividualInvestorInfo",
                            "TaxFileNumber",
                            e.target.value,
                            0
                          )
                        }
                        type="text"
                        placeholder="Enter Tax ID / TFN / SSN"
                      />
                      {errors?.[0]?.TaxFileNumber && (
                        <p className="error">{errors?.[0]?.TaxFileNumber}</p>
                      )}
                    </label>
                    <label>
                      {htmlStr[24] && parser(htmlStr[24])}
                      <input
                        className={`input-claase ${
                          errors?.[0]?.Email && "error-input"
                        }`}
                        name="Email"
                        value={
                          formData?.SafeIndividualInvestorInfo?.[0]?.Email || ""
                        }
                        onChange={(e) =>
                          updateForm(
                            "SafeIndividualInvestorInfo",
                            "Email",
                            e.target.value,
                            0
                          )
                        }
                        type="Email"
                        placeholder="username@domain.com"
                      />
                      {errors?.[0]?.Email && (
                        <p className="error">{errors?.[0]?.Email}</p>
                      )}
                    </label>
                  </div>
                  <div className="form-row">
                    <label>
                      {htmlStr[74] && parser(htmlStr[74])}
                      <SmartSelect
                        id="city_45565765675"
                        isMulti={false}
                        options={countryOptions}
                        value={
                          formData?.SafeIndividualInvestorInfo?.[0]
                            ?.TaxResidencyCountry
                        }
                        onChange={(selected: {
                          value: string;
                          label: string;
                        }) => {
                          setFormData((prev: any) => {
                            const updated = {
                              ...prev,
                              SafeIndividualInvestorInfo:
                                prev?.SafeIndividualInvestorInfo?.map(
                                  (item: any, index: number) =>
                                    index === 0
                                      ? {
                                          ...item,
                                          TaxResidencyCountry: selected,
                                        }
                                      : item
                                ),
                            };

                            debouncedSave(updated);
                            return updated;
                          });
                          validateField(
                            "TaxResidencyCountry",
                            selected.value,
                            0
                          );
                        }}
                        styles={darkSelectStyles}
                        className={` ${
                          errors?.[0]?.TaxResidencyCountry && "error-inpust"
                        }`}
                        placeholder="Select country "
                      />

                      {errors?.[0]?.TaxResidencyCountry && (
                        <p className="error">
                          {errors?.[0]?.TaxResidencyCountry}
                        </p>
                      )}
                    </label>
                    <label>
                      {htmlStr[75] && parser(htmlStr[75])}
                      <input
                        className={`input-claase ${
                          errors?.[0]?.PassportNumber && "error-input"
                        }`}
                        name="PassportNumber"
                        value={
                          formData?.SafeIndividualInvestorInfo?.[0]
                            ?.PassportNumber || ""
                        }
                        onChange={(e) =>
                          updateForm(
                            "SafeIndividualInvestorInfo",
                            "PassportNumber",
                            e.target.value,
                            0
                          )
                        }
                        placeholder="Enter passport number"
                      />
                      {errors?.[0]?.PassportNumber && (
                        <p className="error">{errors?.[0]?.PassportNumber}</p>
                      )}
                    </label>
                    <label>
                      {htmlStr[76] && parser(htmlStr[76])}
                      <input
                        className={`input-claase ${
                          errors?.[0]?.DriversLicenseNumber && "error-input"
                        }`}
                        onChange={(e) =>
                          updateForm(
                            "SafeIndividualInvestorInfo",
                            "DriversLicenseNumber",
                            e.target.value,
                            0
                          )
                        }
                        name="DriversLicenseNumber"
                        value={
                          formData?.SafeIndividualInvestorInfo?.[0]
                            ?.DriversLicenseNumber || ""
                        }
                        placeholder="Enter driver’s license number"
                      />
                      {errors?.[0]?.DriversLicenseNumber && (
                        <p className="error">
                          {errors?.[0]?.DriversLicenseNumber}
                        </p>
                      )}
                    </label>
                  </div>
                  <div className="form-row">
                    <label>
                      {htmlStr[77] && parser(htmlStr[77])}
                      <select
                        onChange={(e: any) => {
                          const selectedInvestorType = e.target.value;
                          updateForm(
                            "SafeIndividualInvestorInfo",
                            "InvestorType",
                            e.target.value,
                            0
                          );
                        }}
                        value={
                          formData?.SafeIndividualInvestorInfo?.[0]
                            ?.InvestorType || ""
                        }
                      >
                        <option value="Accredited">Accredited</option>
                        <option value="Sophisticated">Sophisticated</option>
                        <option value="Professional">Professional</option>
                        <option value="Qualified">Qualified</option>
                      </select>
                    </label>

                    {errors?.[0]?.InvestorType && (
                      <p className="error">{errors?.[0]?.InvestorType}</p>
                    )}
                  </div>
                </form>
              </div>
            </div>

            {formData?.SafeIndividualInvestorInfo?.length == 2 && (
              <div className="investor-form-container">
                <div className="investor-from-dev">
                  <form className="investor-form">
                    <div className="form-row">
                      <label>
                        {htmlStr[26] && parser(htmlStr[26])}
                        <input
                          name="CompanyName"
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]
                              ?.CompanyName
                          }
                          onChange={(e) =>
                            updateForm(
                              "SafeIndividualInvestorInfo",
                              "CompanyName",
                              e.target.value,
                              1
                            )
                          }
                          className={`input-claase ${
                            errors?.[1]?.CompanyName && "error-input"
                          }`}
                          type="text"
                          placeholder="Enter company name"
                        />
                        {errors?.[1]?.CompanyName && (
                          <p className="error">{errors?.[1]?.CompanyName}</p>
                        )}
                      </label>
                      <label>
                        {htmlStr[29] && parser(htmlStr[29])}
                        <input
                          name="BusinessRegistrationNumber"
                          value={
                            formData?.SafeIndividualInvestorInfo[1]
                              ?.BusinessRegistrationNumber
                          }
                          onChange={(e) =>
                            updateForm(
                              "SafeIndividualInvestorInfo",
                              "BusinessRegistrationNumber",
                              e.target.value,
                              1
                            )
                          }
                          className={`input-claase ${
                            errors?.[1]?.BusinessRegistrationNumber &&
                            "error-input"
                          }`}
                          type="text"
                          placeholder="Enter business registration number here"
                        />
                        {errors?.[1]?.BusinessRegistrationNumber && (
                          <p className="error">
                            {errors?.[1]?.BusinessRegistrationNumber}
                          </p>
                        )}
                      </label>
                      <label>
                        {htmlStr[78] && parser(htmlStr[78])}
                        <input
                          type="text"
                          name="CompanyType"
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]
                              ?.CompanyType
                          }
                          onChange={(e) =>
                            updateForm(
                              "SafeIndividualInvestorInfo",
                              "CompanyType",
                              e.target.value,
                              1
                            )
                          }
                          placeholder="Enter company type"
                          className={`input-claase ${
                            errors?.[1]?.CompanyType && "error-input"
                          }`}
                        />
                        {errors?.[1]?.CompanyType && (
                          <p className="error">{errors[1].CompanyType}</p>
                        )}
                      </label>
                    </div>
                    <div className="form-row">
                      <label>
                        {htmlStr[79] && parser(htmlStr[79])}
                        <SmartSelect
                          id="country_reg_15643353"
                          isMulti={false}
                          options={countryOptions}
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]
                              ?.CountryOfRegistration
                          }
                          onChange={(selected: {
                            value: string;
                            label: string;
                          }) => {
                            setFormData((prev: any) => {
                              const currentCountry =
                                prev?.SafeIndividualInvestorInfo?.[0]?.Country
                                  ?.value;

                              const hasCountryChanged =
                                currentCountry !== selected?.value;

                              const updated = {
                                ...prev,
                                SafeIndividualInvestorInfo:
                                  prev.SafeIndividualInvestorInfo.map(
                                    (item: any, index: number) =>
                                      index === 1
                                        ? {
                                            ...item,
                                            CountryOfRegistration: selected,

                                            TaxResidencyCountry:
                                              hasCountryChanged
                                                ? ""
                                                : item.TaxResidencyCountry,
                                          }
                                        : item
                                  ),
                              };

                              debouncedSave(updated);
                              return updated;
                            });

                            validateField(
                              "CountryOfRegistration",
                              selected.value,
                              1
                            );
                          }}
                          className={`${
                            errors?.[1]?.CountryOfRegistration
                              ? "error-inputd"
                              : ""
                          }`}
                          styles={darkSelectStyles}
                          placeholder="Select country"
                        />

                        {errors?.[1]?.CountryOfRegistration && (
                          <p className="error">
                            {errors?.[1]?.CountryOfRegistration}
                          </p>
                        )}
                      </label>

                      <label>
                        {htmlStr[79] && parser(htmlStr[82])}
                        <SmartSelect
                          id="city_21344454677"
                          isMulti={false}
                          options={getStateOptions(
                            formData?.SafeIndividualInvestorInfo?.[1]
                              ?.CountryOfRegistration?.value
                          )}
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]
                              ?.TaxResidencyCountry
                          }
                          onChange={(selected: {
                            value: string;
                            label: string;
                          }) => {
                            setFormData((prev: any) => {
                              const currentState =
                                prev.SafeIndividualInvestorInfo?.[1]
                                  ?.TaxResidencyCountry?.value;

                              const updated = {
                                ...prev,
                                SafeIndividualInvestorInfo:
                                  prev.SafeIndividualInvestorInfo.map(
                                    (item: any, index: number) =>
                                      index === 1
                                        ? {
                                            ...item,
                                            TaxResidencyCountry: selected,
                                          }
                                        : item
                                  ),
                              };

                              debouncedSave(updated);
                              return updated;
                            });
                            validateField(
                              "TaxResidencyCountry",
                              selected.value,
                              1
                            );
                          }}
                          className={`  ${
                            errors?.[1]?.TaxResidencyCountry && "error-input"
                          }`}
                          styles={darkSelectStyles}
                          placeholder="Select region"
                          isDisabled={
                            !formData?.SafeIndividualInvestorInfo?.[1]
                              ?.CountryOfRegistration
                          }
                        />
                        {/* <RegionDropdown
                          country={
                            formData?.SafeIndividualInvestorInfo?.[1]
                              ?.CountryOfRegistration ?? ""
                          }
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]
                              ?.TaxResidencyCountry ?? ""
                          }
                           customRender={customRender}
                        
                          className={`  ${
                            errors?.[1]?.TaxResidencyCountry
                              ? "error-input-c"
                              : ""
                          }`}
                          placeholder="Select region"
                          customProps={{
                            reactSelectValue: formData
                              ?.SafeIndividualInvestorInfo?.[1]
                              ?.TaxResidencyCountry
                              ? {
                                  value:
                                    formData.SafeIndividualInvestorInfo[1]
                                      .TaxResidencyCountry,
                                  label:
                                    formData.SafeIndividualInvestorInfo[1]
                                      .TaxResidencyCountry,
                                }
                              : null,
                            onChange: (
                              selected: { label: string; value: string } | null
                            ) => {
                              const selectedValue = selected?.value || "";

                              const updated = {
                                ...formData,
                                SafeIndividualInvestorInfo:
                                  formData?.SafeIndividualInvestorInfo?.map(
                                    (item: any, index: number) =>
                                      index === 1
                                        ? {
                                            ...item,
                                            TaxResidencyCountry: selectedValue,
                                          }
                                        : item
                                  ),
                              };

                              setFormData(updated);
                              debouncedSave(updated);
                              validateField(
                                "TaxResidencyCountry",
                                selectedValue,
                                1
                              ); // ✅ FIX: no extra space
                            },
                          }}
                        /> */}

                        {errors?.[1]?.TaxResidencyCountry && (
                          <p className="error">
                            {errors?.[1]?.TaxResidencyCountry}
                          </p>
                        )}
                      </label>
                      <label>
                        {htmlStr[30] && parser(htmlStr[30])}
                        <input
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]
                              ?.TaxFileNumber
                          }
                          onChange={(e) =>
                            updateForm(
                              "SafeIndividualInvestorInfo",
                              "TaxFileNumber",
                              e.target.value,
                              1
                            )
                          }
                          className={`input-claase ${
                            errors?.[1]?.TaxFileNumber && "error-input"
                          }`}
                          type="text"
                          placeholder="Enter tax file number here"
                        />
                        {errors?.[1]?.TaxFileNumber && (
                          <p className="error">{errors?.[1]?.TaxFileNumber}</p>
                        )}
                      </label>
                      <label>
                        {htmlStr[31] && parser(htmlStr[31])}
                        <input
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]
                              ?.CompanyWebSite
                          }
                          onChange={(e) =>
                            updateForm(
                              "SafeIndividualInvestorInfo",
                              "CompanyWebSite",
                              e.target.value,
                              1
                            )
                          }
                          className={`input-claase ${
                            errors?.[1]?.CompanyWebSite && "error-input"
                          }`}
                          type="text"
                          placeholder="Enter company url here"
                        />
                        {errors?.[1]?.CompanyWebSite && (
                          <p className="error">{errors?.[1]?.CompanyWebSite}</p>
                        )}
                      </label>
                    </div>
                    <div className="form-row">
                      <label className="full-width">
                        {htmlStr[17] && parser(htmlStr[17])}
                        <input
                          name="Address"
                          className={`input-claase ${
                            errors?.[1]?.Address && "error-input"
                          }`}
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]?.Address
                          }
                          onChange={(e) =>
                            updateForm(
                              "SafeIndividualInvestorInfo",
                              "Address",
                              e.target.value,
                              1
                            )
                          }
                          type="text"
                          placeholder="Enter address here"
                        />
                        {errors?.[1]?.Address && (
                          <p className="error">{errors?.[1]?.Address}</p>
                        )}
                      </label>
                    </div>
                    <div className="form-row">
                      <label>
                        {htmlStr[18] && parser(htmlStr[18])}
                        <SmartSelect
                          id="city_5"
                          isMulti={false}
                          options={countryOptions}
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]?.Country
                          }
                          onChange={(selected: {
                            value: string;
                            label: string;
                          }) => {
                            setFormData((prev: any) => {
                              const currentCountry =
                                prev.SafeIndividualInvestorInfo?.[1]?.Country
                                  ?.value;

                              const hasCountryChanged =
                                currentCountry !== selected?.value;

                              const updated = {
                                ...prev,
                                SafeIndividualInvestorInfo:
                                  prev?.SafeIndividualInvestorInfo?.map(
                                    (item: any, index: number) =>
                                      index === 1
                                        ? {
                                            ...item,
                                            Country: selected,
                                            State: hasCountryChanged
                                              ? ""
                                              : item.State,
                                            City: hasCountryChanged
                                              ? ""
                                              : item.City,
                                          }
                                        : item
                                  ),
                              };

                              debouncedSave(updated);
                              return updated;
                            });
                            validateField("Country", selected.value, 1);
                          }}
                          styles={darkSelectStyles}
                          className={`  ${
                            errors?.[1]?.Country && "error-input"
                          }`}
                          placeholder="Select country"
                        />

                        {errors?.[1]?.Country && (
                          <p className="error">{errors?.[1]?.Country}</p>
                        )}
                      </label>
                      <label>
                        {htmlStr[19] && parser(htmlStr[19])}
                        <SmartSelect
                          id="city_6"
                          isMulti={false}
                          options={getStateOptions(
                            formData?.SafeIndividualInvestorInfo?.[1]?.Country
                              ?.value
                          )}
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]?.State
                          }
                          onChange={(selected: {
                            value: string;
                            label: string;
                          }) => {
                            setFormData((prev: any) => {
                              const currentState =
                                prev.SafeIndividualInvestorInfo?.[1]?.State
                                  ?.value;

                              const hasStateChanged =
                                currentState !== selected?.value;

                              const updated = {
                                ...prev,
                                SafeIndividualInvestorInfo:
                                  prev?.SafeIndividualInvestorInfo?.map(
                                    (item: any, index: number) =>
                                      index === 1
                                        ? {
                                            ...item,
                                            State: selected,
                                            City: hasStateChanged
                                              ? ""
                                              : item.City,
                                          }
                                        : item
                                  ),
                              };

                              debouncedSave(updated);
                              return updated;
                            });
                            validateField("State", selected.value, 1);
                          }}
                          className={`  ${errors?.[1]?.state && "error-input"}`}
                          styles={darkSelectStyles}
                          placeholder="Select state"
                          isDisabled={
                            !formData?.SafeIndividualInvestorInfo?.[1]?.Country
                          }
                        />

                        {errors?.[1]?.state && (
                          <p className="error">{errors?.[1].State}</p>
                        )}
                      </label>
                      <label>
                        {htmlStr[20] && parser(htmlStr[20])}
                        <SmartSelect
                          id="city_7"
                          isMulti={false}
                          options={getCityOptions(
                            formData?.SafeIndividualInvestorInfo?.[1]?.Country
                              ?.value,
                            formData?.SafeIndividualInvestorInfo?.[1]?.State
                              ?.value
                          )}
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]?.City
                          }
                          onChange={(selected: {
                            value: string;
                            label: string;
                          }) => {
                            setFormData((prev: any) => {
                              const updated = {
                                ...prev,
                                SafeIndividualInvestorInfo:
                                  prev.SafeIndividualInvestorInfo.map(
                                    (item: any, index: number) =>
                                      index === 1
                                        ? { ...item, City: selected }
                                        : item
                                  ),
                              };

                              debouncedSave(updated);
                              return updated;
                            });
                            validateField("City", selected.value, 1);
                          }}
                          className={` ${errors?.[1]?.City && "error-input"}`}
                          styles={darkSelectStyles}
                          placeholder="Select city"
                          isDisabled={
                            !formData?.SafeIndividualInvestorInfo?.[1]?.State
                          }
                        />

                        {errors?.[1]?.City && (
                          <p className="error">{errors?.[1].City}</p>
                        )}
                      </label>
                      <label>
                        {htmlStr[21] && parser(htmlStr[21])}
                        {formData?.SafeIndividualInvestorInfo[1] && (
                          <input
                            name="PostalCode"
                            value={
                              formData?.SafeIndividualInvestorInfo[1]
                                ?.PostalCode ?? ""
                            }
                            onChange={(e) =>
                              updateForm(
                                "SafeIndividualInvestorInfo",
                                "PostalCode",
                                e.target.value,
                                1
                              )
                            }
                            className={`input-claase ${
                              errors?.[1]?.PostalCode && "error-input"
                            }`}
                            type="text"
                            placeholder="Enter postal code here"
                          />
                        )}
                        {errors?.[1]?.PostalCode && (
                          <p className="error">{errors?.[1]?.PostalCode}</p>
                        )}
                      </label>
                    </div>
                    <div className="form-row">
                      <div className="dark-phone-input">
                        <label style={{ marginBottom: "6px" }}>
                          {htmlStr[11] && parser(htmlStr[32])}
                        </label>
                        <PhoneInput
                          country={"us"}
                          inputClass={`${
                            errors?.[1]?.OfficeNumber ? "error-input" : ""
                          }`}
                          inputStyle={darkPhoneInputStyle}
                          // Apply the dark theme style to the button (flag/dropdown)
                          buttonStyle={darkPhoneInputButtonStyle}
                          // Apply container styles (like margin-top and overall border-radius)
                          containerStyle={darkPhoneInputContainerStyle}
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]
                              ?.OfficeNumber
                          }
                          onChange={(phone: string) => {
                            setFormData((prev: any) => {
                              const updated = {
                                ...prev,
                                SafeIndividualInvestorInfo:
                                  prev?.SafeIndividualInvestorInfo?.map(
                                    (item: any, index: number) =>
                                      index === 1
                                        ? { ...item, OfficeNumber: phone }
                                        : item
                                  ),
                              };
                              debouncedSave(updated);
                              return updated;
                            });
                            validateField("OfficeNumber", phone, 1);
                          }}
                          inputProps={{
                            name: "OfficeNumber",
                            required: true,
                          }}
                        />
                        {/* {errors?.[1]?.OfficeNumber && (
                            <p className="error">{errors?.[1]?.OfficeNumber}</p>
                          )} */}
                      </div>
                      <label>
                        {htmlStr[80] && parser(htmlStr[80])}
                        <input
                          type="text"
                          className={"input-claase"}
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]
                              ?.GovernmentRegistrationUrl
                          }
                          onChange={(e) =>
                            updateForm(
                              "SafeIndividualInvestorInfo",
                              "GovernmentRegistrationUrl",
                              e.target.value,
                              1
                            )
                          }
                          placeholder="Enter government registration url"
                        />
                        {errors?.[1]?.GovernmentRegistrationUrl && (
                          <p className="error">
                            {errors[1].GovernmentRegistrationUrl}
                          </p>
                        )}
                      </label>
                      <label>
                        {htmlStr[34] && parser(htmlStr[34])}
                        <input
                          className={`input-claase ${
                            errors?.[1]?.OfficeEmail && "error-input"
                          }`}
                          name="OfficeEmail"
                          value={
                            formData?.SafeIndividualInvestorInfo?.[1]
                              ?.OfficeEmail
                          }
                          onChange={(e) =>
                            updateForm(
                              "SafeIndividualInvestorInfo",
                              "OfficeEmail",
                              e.target.value,
                              1
                            )
                          }
                          type="OfficeEmail"
                          placeholder="username@domain.com"
                        />
                        {errors?.[1]?.OfficeEmail && (
                          <p className="error">{errors?.[1]?.OfficeEmail}</p>
                        )}
                      </label>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </>
        )}

        {currentStep == 3 && htmlStrRemoved.length > 2 && (
          <div className="attachment-investor-container">
            {htmlStr[39] && parser(htmlStr[39])}
            {htmlStr[40] && !formData?.CompanyRepresentative && (
              <>
                <p className="attachment-investor-name">
                  Investor First Last Name :{" "}
                  {formData?.SafeIndividualInvestorInfo[0]?.FirstName}{" "}
                  {formData?.SafeIndividualInvestorInfo[0]?.LastName}{" "}
                </p>
              </>
            )}
            {htmlStr[17] && formData?.CompanyRepresentative && (
              <p className="attachment-investor-name">
                {" "}
                Company Name:{" "}
                {formData?.SafeIndividualInvestorInfo[1]?.CompanyName}
              </p>
            )}

            <div className="grid-investor-doc">
              <div>
                {["GovernmentIssuedID", "ProofOfAddress"].map(
                  (fileType, index) => (
                    <div
                      key={fileType}
                      style={{ position: "relative", marginBottom: "20px" }}
                    >
                      <div className="attachment-investor-upload-box ss">
                        <p className="attachment-investor-label">
                          {htmlStr[35 + index] && parser(htmlStr[35 + index])}
                        </p>
                        <div className="attachment-investor-upload-container">
                          <div className="attachment-investor-icon">
                            {formData?.Attachment[
                              fileType as keyof FileUploadProps
                            ] ? (
                              <img
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  borderRadius: "10px",
                                }}
                                src={
                                  isPDFFile(
                                    formData?.Attachment[
                                      fileType as keyof FileUploadProps
                                    ]
                                  )
                                    ? "https://public.ticca.com/images/svg/Pdf.svg"
                                    : (formData?.Attachment[
                                        `${fileType}Data` as keyof FileUploadProps
                                      ] as string)
                                }
                                alt={fileType}
                              />
                            ) : (
                              // Fallback SVG icon
                              <img src="https://public.ticca.com/images/svg/Image_Thumbnil.svg" />
                            )}
                          </div>
                          <div className="attachment-investor-file-input">
                            <p>Please upload jpg, jpeg, png, or pdf file</p>
                            <div className="attachment-investor-file-upload">
                              <input
                                type="file"
                                id={`fileUpload-${index}`}
                                accept=".pdf,.jpg,.jpeg,.png"
                                style={{
                                  zIndex: 9999,
                                  width: "100px",
                                  height: "20px",
                                  opacity: 0,
                                  cursor: "pointer",
                                  position: "absolute",
                                  transform: "translateY(2px)",
                                }}
                                onChange={(e) =>
                                  handleFileChange(
                                    e,
                                    fileType as keyof FileUploadProps
                                  )
                                }
                              />
                              <label
                                htmlFor={`fileUpload-${index}`}
                                className="attachment-investor-upload-button"
                              >
                                Choose File
                              </label>
                              <span className="attachment-investor-file-text">
                                {formData?.Attachment[
                                  fileType as keyof FileUploadProps
                                ]
                                  ? formData?.Attachment[
                                      fileType as keyof FileUploadProps
                                    ].length > 15
                                    ? formData?.Attachment[
                                        fileType as keyof FileUploadProps
                                      ].substring(0, 5) + "..."
                                    : formData?.Attachment[
                                        fileType as keyof FileUploadProps
                                      ]
                                  : "No File Chosen"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>

              {formData.CompanyRepresentative && (
                <div>
                  {[
                    "EmploymentProofOfRepresentation",
                    "CertificateOfIncorporation",
                  ].map((fileType, index) => (
                    <div
                      key={fileType}
                      style={{ position: "relative", marginBottom: "20px" }}
                    >
                      <div className="attachment-investor-upload-box ss">
                        <p className="attachment-investor-label">
                          {htmlStr[37 + index] && parser(htmlStr[37 + index])}
                        </p>
                        <div className="attachment-investor-upload-container">
                          <div className="attachment-investor-icon">
                            {formData?.Attachment[
                              fileType as keyof FileUploadProps
                            ] ? (
                              <img
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  borderRadius: "10px",
                                }}
                                src={
                                  isPDFFile(
                                    formData?.Attachment[
                                      fileType as keyof FileUploadProps
                                    ]
                                  )
                                    ? "https://public.ticca.com/images/svg/Pdf.svg"
                                    : (formData?.Attachment[
                                        `${fileType}Data` as keyof FileUploadProps
                                      ] as string)
                                }
                                alt={fileType}
                              />
                            ) : (
                              <img src="https://public.ticca.com/images/svg/Image_Thumbnil.svg" />
                            )}
                          </div>
                          <div className="attachment-investor-file-input">
                            <p>Please upload jpg, jpeg, png, or pdf file</p>
                            <div className="attachment-investor-file-upload">
                              <input
                                type="file"
                                id={`fileUpload-company-${index}`}
                                accept=".pdf,.jpg,.jpeg,.png"
                                style={{
                                  zIndex: 9999,
                                  width: "100px",
                                  height: "20px",
                                  opacity: 0,
                                  cursor: "pointer",
                                  position: "absolute",
                                  transform: "translateY(2px)",
                                }}
                                onChange={(e) =>
                                  handleFileChange(
                                    e,
                                    fileType as keyof FileUploadProps
                                  )
                                }
                              />
                              <label
                                htmlFor={`fileUpload-company-${index}`}
                                className="attachment-investor-upload-button"
                              >
                                Choose File
                              </label>
                              <span className="attachment-investor-file-text">
                                {formData?.Attachment[
                                  fileType as keyof FileUploadProps
                                ]
                                  ? formData?.Attachment[
                                      fileType as keyof FileUploadProps
                                    ].length > 15
                                    ? formData?.Attachment[
                                        fileType as keyof FileUploadProps
                                      ].substring(0, 5) + "..."
                                    : formData?.Attachment[
                                        fileType as keyof FileUploadProps
                                      ]
                                  : "No File Chosen"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
        {currentStep == 4 && htmlStrRemoved.length > 2 && (
          <>
            <div className="amount-investor-container">
              {htmlStr[41] && parser(htmlStr[41])}
              <div className="amount-investor-currency-subscription">
                <label>
                  {htmlStr[44] && parser(htmlStr[44])}
                  <select
                    onChange={(e: any) => {
                      const selectedCurrency = e.target.value;

                      setFormData((prev: any) => {
                        const updated = {
                          ...prev,
                          SafeIndividualInvestorAmount: {
                            ...prev.SafeIndividualInvestorAmount,
                            SelectCurrency: selectedCurrency,
                          },
                        };
                        debouncedSave(updated);
                        return updated;
                      });
                    }}
                    value={
                      formData?.SafeIndividualInvestorAmount?.SelectCurrency ||
                      "USD"
                    }
                  >
                    <option>USD</option>
                  </select>
                </label>
                <label>
                  {htmlStr[45] && parser(htmlStr[45])}
                  <input
                    type="number"
                    min="0"
                    className={`${investorAmout ? "error-amount" : ""}`}
                    onChange={(e: any) => {
                      const subscriptionAmount = Number(e.target.value);
                      if (subscriptionAmount < 0) return; // Prevent negative input
                      setFormData((prev: any) => {
                        const updated = {
                          ...prev,
                          SafeIndividualInvestorAmount: {
                            ...prev.SafeIndividualInvestorAmount,
                            SubscriptionAmount: subscriptionAmount,
                          },
                        };
                        debouncedSave(updated);
                        return updated;
                      });
                      if (subscriptionAmount < 0 || !e.target.value) {
                        setInvestorAmount(true);
                      } else {
                        setInvestorAmount(false);
                      }
                    }}
                    value={
                      formData.SafeIndividualInvestorAmount
                        ?.SubscriptionAmount || ""
                    }
                    placeholder="Enter amount here"
                  />
                  {investorAmout && (
                    <p style={{ color: "red" }} className="error">
                      please enter amount
                    </p>
                  )}
                </label>
              </div>
            </div>
          </>
        )}
        {currentStep == 5 && htmlStrRemoved.length > 2 && (
          <div className="investor-form-container">
            <div className="investor-from-dev">
              <p className="form-description">
                <strong>
                  5. Bank Information of{" "}
                  {formData?.CompanyRepresentative
                    ? `${formData?.SafeIndividualInvestorInfo[1]?.CompanyName}`
                    : `${formData?.SafeIndividualInvestorInfo[0]?.FirstName} ${formData?.SafeIndividualInvestorInfo[0]?.LastName}`}{" "}
                </strong>
              </p>
              <form className="investor-form">
                <div className="form-row">
                  <label>
                    {htmlStr[47] && parser(htmlStr[47])}
                    <input
                      value={
                        formData?.SafeIndividualInvestorBank?.BankName || ""
                      }
                      onChange={(e: any) =>
                        handleBankInputChange(
                          "BankName",
                          e.target.value,
                          validateFieldBank
                        )
                      }
                      className={`input-claase ${
                        bankerror?.BankName && "error-input"
                      }`}
                      type="text"
                      placeholder="Enter bank name"
                    />
                    {bankerror?.BankName && (
                      <p className="error">{bankerror?.BankName}</p>
                    )}
                  </label>
                  <label>
                    {htmlStr[48] && parser(htmlStr[48])}
                    <input
                      value={
                        formData?.SafeIndividualInvestorBank
                          ?.AccountHolderName || ""
                      }
                      onChange={(e: any) =>
                        handleBankInputChange(
                          "AccountHolderName",
                          e.target.value,
                          validateFieldBank
                        )
                      }
                      className={`input-claase ${
                        bankerror?.AccountHolderName && "error-input"
                      }`}
                      type="text"
                      placeholder="Enter account holder Name"
                    />
                    {bankerror?.AccountHolderName && (
                      <p className="error">{bankerror?.AccountHolderName}</p>
                    )}
                  </label>
                  <label>
                    {htmlStr[49] && parser(htmlStr[49])}
                    <input
                      className={`input-claase ${
                        bankerror?.AccountNumber && "error-input"
                      }`}
                      value={
                        formData?.SafeIndividualInvestorBank?.AccountNumber ||
                        ""
                      }
                      onChange={(e: any) =>
                        handleBankInputChange(
                          "AccountNumber",
                          e.target.value,

                          validateFieldBank
                        )
                      }
                      type="text"
                      placeholder="Enter account number"
                    />
                    {bankerror?.AccountNumber && (
                      <p className="error">{bankerror?.AccountNumber}</p>
                    )}
                  </label>
                </div>

                <div className="form-row">
                  <label>
                    {htmlStr[50] && parser(htmlStr[50])}
                    <input
                      value={formData?.SafeIndividualInvestorBank?.BSB || ""}
                      onChange={(e: any) =>
                        handleBankInputChange(
                          "BSB",
                          e.target.value,

                          validateFieldBank
                        )
                      }
                      type="text"
                      placeholder="Enter BSB number"
                      className={`input-claase ${
                        bankerror?.BSB && "error-input"
                      }`}
                    />
                    {bankerror?.BSB && (
                      <p className="error">{bankerror?.BSB}</p>
                    )}
                  </label>
                  <label>
                    {htmlStr[51] && parser(htmlStr[51])}
                    <input
                      value={
                        formData?.SafeIndividualInvestorBank?.SwiftCode || ""
                      }
                      onChange={(e: any) =>
                        handleBankInputChange(
                          "SwiftCode",
                          e.target.value,

                          validateFieldBank
                        )
                      }
                      type="text"
                      placeholder="Enter swift code"
                      className={`input-claase ${
                        bankerror?.SwiftCode && "error-input"
                      }`}
                    />
                    {bankerror?.SwiftCode && (
                      <p className="error">{bankerror?.SwiftCode}</p>
                    )}
                  </label>
                  <label>
                    {htmlStr[52] && parser(htmlStr[52])}
                    <input
                      value={
                        formData?.SafeIndividualInvestorBank.IBANNumber || ""
                      }
                      onChange={(e: any) =>
                        handleBankInputChange(
                          "IBANNumber",
                          e.target.value,

                          validateFieldBank
                        )
                      }
                      type="text"
                      placeholder=" Enter IBAN number"
                      className={`input-claase ${
                        bankerror?.IBANNumber && "error-input"
                      }`}
                    />
                    {bankerror?.IBANNumber && (
                      <p className="error">{bankerror?.IBANNumber}</p>
                    )}
                  </label>
                </div>

                <div className="form-row">
                  <label className="full-width">
                    {htmlStr[53] && parser(htmlStr[53])}
                    <input
                      value={
                        formData?.SafeIndividualInvestorBank?.BranchAddress ||
                        ""
                      }
                      onChange={(e: any) =>
                        handleBankInputChange(
                          "BranchAddress",
                          e.target.value,
                          validateFieldBank
                        )
                      }
                      type="text"
                      placeholder="Enter address here"
                      className={`input-claase ${
                        bankerror?.BranchAddress && "error-input"
                      }`}
                    />
                    {bankerror?.BranchAddress && (
                      <p className="error">{bankerror?.BranchAddress}</p>
                    )}
                  </label>
                </div>
                <div className="form-row">
                  <div className="dark-phone-input">
                    {" "}
                    <label style={{ marginBottom: "6px" }}>
                      {htmlStr[22] && parser(htmlStr[22])}
                    </label>
                    <PhoneInput
                      country={"us"}
                      inputClass={`${
                        bankerror.BankPhoneNumber ? "error-input" : ""
                      }`}
                      inputStyle={darkPhoneInputStyle}
                      // Apply the dark theme style to the button (flag/dropdown)
                      buttonStyle={darkPhoneInputButtonStyle}
                      // Apply container styles (like margin-top and overall border-radius)
                      containerStyle={darkPhoneInputContainerStyle}
                      value={
                        formData?.SafeIndividualInvestorBank?.BankPhoneNumber ||
                        ""
                      }
                      onChange={(phone: string) => {
                        setFormData((prev: any) => {
                          const updated = {
                            ...prev,
                            SafeIndividualInvestorBank: {
                              ...prev.SafeIndividualInvestorBank,
                              BankPhoneNumber: phone,
                            },
                          };
                          debouncedSave(updated);
                          return updated;
                        });
                        validateFieldBank("BankPhoneNumber", phone);
                      }}
                      inputProps={{
                        name: "BankPhoneNumber",
                        required: true,
                      }}
                    />
                    {bankerror.BankPhoneNumber && (
                      <p className="error">{bankerror.BankPhoneNumber}</p>
                    )}
                  </div>

                  <label>
                    Email
                    <input
                      value={formData?.SafeIndividualInvestorBank?.Email || ""}
                      onChange={(e) =>
                        updateForm(
                          "SafeIndividualInvestorBank",
                          "Email",
                          e.target.value
                        )
                      }
                      className={`input-claase ${
                        bankerror?.Email && "error-input"
                      }`}
                      type="text"
                      placeholder="Enter email here"
                    />
                    {bankerror.Email && (
                      <p className="error">{bankerror.Email}</p>
                    )}
                  </label>
                  <label>
                    Website (If applicable)
                    <input
                      value={
                        formData?.SafeIndividualInvestorBank?.WebSite || ""
                      }
                      onChange={(e) =>
                        updateForm(
                          "SafeIndividualInvestorBank",
                          "WebSite",
                          e.target.value
                        )
                      }
                      className={`input-claase ${
                        bankerror.WebSite && "error-input"
                      }`}
                      type="text"
                      placeholder="Enter Bank's website url here"
                    />
                    {bankerror.WebSite && (
                      <p className="error">{bankerror.WebSite}</p>
                    )}
                  </label>
                </div>
                <div className="form-row">
                  <label>
                    {htmlStr[54] && parser(htmlStr[54])}
                    <SmartSelect
                      id="city_8"
                      isMulti={false}
                      options={countryOptions}
                      value={formData?.SafeIndividualInvestorBank?.Country}
                      className={` ${bankerror.Country && "error-input"}`}
                      styles={darkSelectStyles}
                      onChange={(selected: {
                        value: string;
                        label: string;
                      }) => {
                        setFormData((prev: any) => {
                          const currentCountry =
                            prev.SafeIndividualInvestorBank?.Country?.value;
                          const hasCountryChanged =
                            currentCountry !== selected?.value;

                          const updated = {
                            ...prev,
                            SafeIndividualInvestorBank: {
                              ...prev.SafeIndividualInvestorBank,
                              Country: selected,
                              State: hasCountryChanged
                                ? ""
                                : prev.SafeIndividualInvestorBank?.State,
                              City: hasCountryChanged
                                ? ""
                                : prev.SafeIndividualInvestorBank?.City,
                            },
                          };

                          debouncedSave(updated);
                          return updated;
                        });
                        validateFieldBank("Country", selected.value);
                      }}
                      placeholder="Select country"
                    />

                    {bankerror?.Country && (
                      <p className="error">{bankerror?.Country}</p>
                    )}
                  </label>
                  <label>
                    {htmlStr[55] && parser(htmlStr[55])}
                    <SmartSelect
                      id="city_9"
                      isMulti={false}
                      options={getStateOptions(
                        formData?.SafeIndividualInvestorBank?.Country?.value
                      )}
                      styles={darkSelectStyles}
                      className={` ${bankerror.State && "error-input"}`}
                      value={formData?.SafeIndividualInvestorBank?.State}
                      onChange={(selected: {
                        value: string;
                        label: string;
                      }) => {
                        setFormData((prev: any) => {
                          const currentState =
                            prev.SafeIndividualInvestorBank?.State?.value;
                          const hasStateChanged =
                            currentState !== selected?.value;

                          const updated = {
                            ...prev,
                            SafeIndividualInvestorBank: {
                              ...prev.SafeIndividualInvestorBank,
                              State: selected,
                              City: hasStateChanged
                                ? ""
                                : prev.SafeIndividualInvestorBank?.City,
                            },
                          };

                          debouncedSave(updated);
                          return updated;
                        });
                        validateFieldBank("State", selected.value);
                      }}
                      placeholder="Select state"
                      isDisabled={
                        !formData?.SafeIndividualInvestorBank?.Country
                      }
                    />

                    {bankerror.State && (
                      <p className="error">{bankerror.State}</p>
                    )}
                  </label>
                  <label>
                    {htmlStr[56] && parser(htmlStr[56])}
                    <SmartSelect
                      id="city_10"
                      isMulti={false}
                      options={getCityOptions(
                        formData?.SafeIndividualInvestorBank?.Country?.value,
                        formData?.SafeIndividualInvestorBank?.State?.value
                      )}
                      styles={darkSelectStyles}
                      className={`  ${bankerror.City && "error-input"}`}
                      value={formData?.SafeIndividualInvestorBank?.City}
                      onChange={(selected: {
                        value: string;
                        label: string;
                      }) => {
                        setFormData((prev: any) => {
                          const updated = {
                            ...prev,
                            SafeIndividualInvestorBank: {
                              ...prev.SafeIndividualInvestorBank,
                              City: selected,
                            },
                          };
                          debouncedSave(updated);
                          return updated;
                        });
                        validateFieldBank("City", selected.value);
                      }}
                      placeholder="Select city"
                      isDisabled={!formData?.SafeIndividualInvestorBank?.State}
                    />

                    {bankerror?.City && (
                      <p className="error">{bankerror?.City}</p>
                    )}
                  </label>
                  <label>
                    {htmlStr[57] && parser(htmlStr[57])}
                    <input
                      value={
                        formData?.SafeIndividualInvestorBank.PostalCode || ""
                      }
                      onChange={(e: any) =>
                        handleBankInputChange(
                          "PostalCode",
                          e.target.value,

                          validateFieldBank
                        )
                      }
                      type="text"
                      placeholder="Enter postal code here"
                      className={`input-claase ${
                        bankerror?.PostalCode && "error-input"
                      }`}
                    />
                    {bankerror?.PostalCode && (
                      <p className="error">{bankerror?.PostalCode}</p>
                    )}
                  </label>
                </div>
              </form>
            </div>
          </div>
        )}

        {currentStep == 6 && htmlStrRemoved.length > 2 && (
          <>
            <div
              style={{ marginTop: "10px" }}
              className="amount-investor-container"
            >
              {htmlStr[60] && parser(htmlStr[60])}

              <div className="amount-investor-dividend-option">
                <div>
                  <label>{htmlStr[61] && parser(htmlStr[61])}</label>
                </div>
                <div>
                  {" "}
                  <label>{htmlStr[62] && parser(htmlStr[62])}</label>
                </div>{" "}
                <div>
                  {" "}
                  <label>{htmlStr[63] && parser(htmlStr[63])}</label>
                </div>{" "}
                <div>
                  {" "}
                  <label>{htmlStr[71] && parser(htmlStr[71])}</label>
                </div>{" "}
                <div>
                  {" "}
                  <label>{htmlStr[72] && parser(htmlStr[72])}</label>
                </div>{" "}
              </div>
            </div>
            <div
              style={{ marginTop: "10px", padding: "10px 70px" }}
              className="amount-investor-container"
            >
              <div className="amount-investor-dividend-option">
                <div>
                  <input
                    checked={
                      formData?.Signatures?.Signatures_i &&
                      formData?.Signatures?.Signatures_ii &&
                      formData?.Signatures?.Signatures_iii &&
                      formData?.Signatures?.Signatures_iv &&
                      formData?.Signatures?.Signatures_v
                    }
                    onChange={(e: any) => {
                      if (e.target.checked) {
                        setOpen(true);
                      } else {
                        setFormData((prev: any) => {
                          const updated = {
                            ...prev,

                            Signatures: {
                              ...prev.Signatures,
                              DeclarationTermsAndCondition: "",
                              Signatures_i: e.target.checked
                                ? htmlStrRemoved[61]
                                : "",
                              Signatures_ii: e.target.checked
                                ? htmlStrRemoved[62]
                                : "",
                              Signatures_iii: e.target.checked
                                ? htmlStrRemoved[63]
                                : "",
                              Signatures_iv: e.target.checked
                                ? htmlStrRemoved[71]
                                : "",
                              Signatures_v: e.target.checked
                                ? htmlStrRemoved[72]
                                : "",
                            },
                          };
                          debouncedSave(updated);
                          return updated;
                        });
                      }
                    }}
                    type="checkbox"
                  />
                  <label style={{ marginTop: "5px" }}>
                    {htmlStr[64] && parser(htmlStr[64])}
                  </label>
                </div>
              </div>
            </div>
            <div className="signature-form-container">
              <div className="grid-signature-form">
                <div>
                  {!formData.CompanyRepresentative ? (
                    <h4>
                      For Individual Investor{" "}
                      {formData?.SafeIndividualInvestorInfo[0]?.FirstName}{" "}
                      {formData?.SafeIndividualInvestorInfo[0]?.LastName}{" "}
                      Applicants:
                    </h4>
                  ) : (
                    <label>
                      <h3>
                        For Company :{" "}
                        {formData?.SafeIndividualInvestorInfo[1]?.CompanyName}
                      </h3>
                    </label>
                  )}
                  <label>{htmlStr[66] && parser(htmlStr[66])}</label>
                  {!formData.CompanyRepresentative ? (
                    <>
                      <input
                        className={`input-field-SIGNATURE  ${
                          signatureError.FullName && "sign-dev-error"
                        } `}
                        value={formData?.Signatures?.FullName || ""}
                        onChange={(e: any) => {
                          validSignuture("FullName", e.target.value);
                          setFormData((prev: any) => {
                            const updated = {
                              ...prev,
                              Signatures: {
                                ...prev.Signatures,
                                FullName: e.target.value,
                              },
                            };
                            debouncedSave(updated);
                            return updated;
                          });
                        }}
                        type="text"
                        placeholder="Enter full name"
                      />
                      {signatureError.FullName && (
                        <p style={{ color: "red" }}>
                          {signatureError.FullName}
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      <input
                        className={`${
                          signatureError.CompanyName && "sign-dev-error"
                        } input-field-SIGNATURE  `}
                        value={formData?.Signatures?.CompanyName}
                        onChange={(e: any) => {
                          validSignuture("CompanyName", e.target.value);
                          setFormData((prev: any) => {
                            const updated = {
                              ...prev,
                              Signatures: {
                                ...prev.Signatures,
                                CompanyName: e.target.value,
                              },
                            };
                            debouncedSave(updated);
                            return updated;
                          });
                        }}
                        type="text"
                        placeholder="Enter company name"
                      />
                      {signatureError.CompanyName && (
                        <p style={{ color: "red" }}>
                          {signatureError.CompanyName}
                        </p>
                      )}
                    </>
                  )}
                  <label>{htmlStr[83] && parser(htmlStr[83])}</label>
                  <input
                    className={`${
                      signatureError.Position && "sign-dev-error"
                    } input-field-SIGNATURE  `}
                    value={formData?.Signatures?.Position}
                    onChange={(e: any) => {
                      validSignuture("Position", e.target.value);
                      setFormData((prev: any) => {
                        const updated = {
                          ...prev,
                          Signatures: {
                            ...prev.Signatures,
                            Position: e.target.value,
                          },
                        };
                        debouncedSave(updated);
                        return updated;
                      });
                    }}
                    type="text"
                    placeholder="Enter position name"
                  />
                  {signatureError.Position && (
                    <p style={{ color: "red" }}>{signatureError.Position}</p>
                  )}
                  <label> {htmlStr[67] && parser(htmlStr[67])}</label>
                  {formData?.Attachment.SignatureData && (
                    <img
                      style={{ width: "100px", height: "100px" }}
                      src={formData?.Attachment.SignatureData}
                      alt="signature"
                    />
                  )}
                  <div className="signature-upload">
                    <div
                      onClick={() => setActiveSignatureIndex(0)}
                      className={`${
                        signatureError.SignatureData && "sign-degv-error"
                      } upload-box  `}
                    >
                      <p>Click to sign or upload your signature </p>
                      <samp>
                        <img src="https://public.ticca.com/images/svg/Upload_Signature.svg" />
                      </samp>
                    </div>

                    {activeSignatureIndex === 0 && (
                      <SignaturePad
                        updatedSignatures={formData?.Attachment?.SignatureData}
                        onSave={(signature) => {
                          const updatedSignatures = { ...formData?.Attachment };
                          if (!updatedSignatures) {
                            return;
                          }
                          validSignuture("SignatureData", signature.extension);
                          setFormData((prev: any) => {
                            const updated = {
                              ...prev,
                              Attachment: {
                                ...prev.Attachment,
                                Signature: signature.name || "",
                                SignatureExtenstion: signature.extension,
                                SignatureData: signature.data,
                              },
                            };

                            debouncedSave(updated);
                            return updated;
                          });

                          setActiveSignatureIndex(null);
                        }}
                        onClose={() => setActiveSignatureIndex(null)}
                      />
                    )}
                  </div>
                  {signatureError.SignatureData && (
                    <p style={{ color: "red" }}>
                      {signatureError.SignatureData}
                    </p>
                  )}
                  {htmlStr[68] && parser(htmlStr[68])}
                  <label> {htmlStr[69] && parser(htmlStr[69])}</label>
                  <div className="date-picker">
                    <samp className="calendar-icon">
                      <img src="https://public.ticca.com/images/svg/Calendar.svg" />
                    </samp>
                    <input
                      value={
                        formData?.Signatures?.Date
                          ? formatDate(formData?.Signatures?.Date)
                          : ""
                      }
                      onChange={(e: any) => {
                        setFormData((prev: any) => {
                          const updated = {
                            ...prev,
                            Signatures: {
                              ...prev.Signatures,
                              Date: e.target.value,
                            },
                          };
                          debouncedSave(updated);
                          return updated;
                        });
                      }}
                      disabled
                      placeholder="YYYY-MM-DD"
                      pattern="\d{4}-\d{2}-\d{2}"
                      style={{ appearance: "none" }}
                      type="date"
                      onKeyDown={(e) => e.preventDefault()} // Prevent typing
                      onPaste={(e) => e.preventDefault()} // Prevent pasting
                      onDrop={(e) => e.preventDefault()} // Prevent dropping text
                      max={new Date().toISOString().split("T")[0]}
                    />
                  </div>
                </div>
                <div>
                  <label>
                    <h3>For Company : TICCA PTY LTD</h3>
                  </label>
                  <label>{htmlStr[66] && parser(htmlStr[66])}</label>
                  <input
                    className="input-field-SIGNATURE"
                    value={"TICCA PTY LTD"}
                    disabled
                    type="text"
                    placeholder="Enter company name"
                  />
                  <label>{htmlStr[83] && parser(htmlStr[83])}</label>
                  <input
                    className="input-field-SIGNATURE"
                    type="text"
                    disabled
                    placeholder="Enter position name"
                  />
                  <label> {htmlStr[67] && parser(htmlStr[67])}</label>

                  <div className="signature-upload">
                    <div className="upload-box">
                      <p>Click to sign or upload your signature </p>
                      <samp>
                        <img src="https://public.ticca.com/images/svg/Upload_Signature.svg" />
                      </samp>
                    </div>
                  </div>
                  {htmlStr[68] && parser(htmlStr[68])}
                  <label> {htmlStr[69] && parser(htmlStr[69])}</label>
                  <div className="date-picker">
                    <samp className="calendar-icon">
                      <img src="https://public.ticca.com/images/svg/Calendar.svg" />
                    </samp>
                    <input
                      value={formatDate(new Date())}
                      disabled
                      placeholder="YYYY-MM-DD"
                      pattern="\d{4}-\d{2}-\d{2}"
                      style={{ appearance: "none" }}
                      type="date"
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Navigtion Buttons */}
        <div className="button-container-investor">
          {currentStep !== 1 && (
            <Button
              className="investor-next-button"
              variant="contained"
              onClick={handleBack}
              startIcon={
                <img
                  src="https://public.ticca.com/images/svg/RightArrow.svg"
                  alt="back-icon"
                />
              }
              // style={{ color: "rgba(7, 78, 220, 1)" }}
              disabled={currentStep === 1}
            >
              Back
            </Button>
          )}

          {currentStep == 6 && (
            <Button
              className="investor-next-button"
              variant="contained"
              onClick={() => {
                debouncedSave(formData);
                toast.success(
                  "Your information has been saved.",
                  toastCommonestyle as any
                );
              }}
              // style={{ color: "rgba(7, 78, 220, 1)" }}
            >
              Save as Draft
            </Button>
          )}
          {currentStep == 6 && (
            <LoadingButton
              className="investor-next-button"
              variant="contained"
              onClick={(e) => {
                e.preventDefault();
                if (validateStep()) {
                  handleSubmit();
                }
              }}
              loading={btnLoading}
              loadingIndicator={
                <CircularProgress size={22} sx={{ color: "#fff" }} />
              }
            >
              Submit
            </LoadingButton>
          )}
          {currentStep < 6 && (
            <Button
              className="investor-next-button"
              variant="contained"
              type="button"
              onClick={(e) => {
                e.preventDefault();
                handleNext();
              }}
              // style={{ background: "rgba(7, 78, 220, 1)" }}
              endIcon={
                <img
                  src="https://public.ticca.com/images/svg/LeftArrow.svg"
                  alt="next-icon"
                />
              }
              // disabled={!isStepValid}
            >
              Next
            </Button>
          )}
        </div>
      </div>
    </>
  );
}
